export const translations = {
  en: {
    // Navigation
    nav: {
      catalog: "Catalog",
      packs: "Packs",
      licenses: "Licenses",
      membership: "Membership",
      services: "Services",
      artists: "Artists",
      about: "About Us",
      login: "Login",
      getStarted: "Get Started",
      dashboard: "Dashboard",
      admin: "Admin Panel",
      logout: "Logout"
    },
    
    // Hero Section
    hero: {
      overline: "Global Music Ecosystem",
      title: "Buy · Download ·",
      titleHighlight: "Distribute",
      subtitle: "Ready-to-release music. Studio-quality WAV + MP3 + exclusive 3000×3000 cover art + certified license — all auto-delivered the moment you pay. Save up to 40% with our 5/10/20 track packs.",
      exploreMusic: "Explore Music",
      buyPacks: "Buy Packs",
      joinMembership: "Join Membership",
      aiPlaceholder: "What kind of music do you need? I'll help you.",
      aiSend: "Send",
      aiRecommended: "Recommended for you:",
      pillarBuy: "BUY READY MUSIC",
      pillarBuyDesc: "97+ pro-mastered tracks. WAV + Cover + License.",
      pillarMaster: "OG MASTERING",
      pillarMasterDesc: "Studio quality in seconds. 8 OG signature presets. From $3.99.",
      tryMastering: "Try OG Mastering",
    },
    
    // About Founder Section
    founder: {
      overline: "About the Founder",
      role: "Founder & Creative Director",
      name: "Hancel Ovalle",
      headline: "Building a global music ecosystem driven by identity, sound, and vision.",
      bio: "As the founder and CEO of OG MUSIC GROUP, Hancel Ovalle has dedicated his career to creating a scalable music ecosystem that bridges the gap between professional sound production and global distribution. With a vision centered on sound identity and strategic positioning, OG MUSIC GROUP has grown into a multi-genre catalog serving creators, artists, and businesses worldwide.",
      highlights: {
        vision: "Global Vision",
        visionDesc: "Building music infrastructure for international reach",
        creative: "Creative Direction",
        creativeDesc: "Curating premium sound experiences",
        scalable: "Scalable System",
        scalableDesc: "Ready-to-release music on demand"
      },
      cta: "Work With Us",
      ctaSecondary: "Start a Project"
    },
    
    // Ecosystem Section
    ecosystem: {
      overline: "The OG Ecosystem",
      title: "Everything You Need to",
      titleHighlight: "Release Music",
      subtitle: "A complete music marketplace designed for professional releases. From ready-to-use tracks to full commercial licensing with worldwide rights.",
      cards: {
        tracks: { title: "Premium Tracks", desc: "Fully mastered, ready-to-release songs from $3 to $10" },
        licensing: { title: "Clear Licensing", desc: "Commercial use allowed with worldwide rights" },
        membership: { title: "Membership", desc: "Download up to unlimited songs monthly" },
        promotion: { title: "Promotion", desc: "Playlist ecosystem for visibility and exposure" }
      }
    },
    
    // Catalog Section
    catalog: {
      overline: "Music Catalog",
      title: "Featured",
      titleHighlight: "Tracks",
      viewAll: "View All Tracks",
      searchPlaceholder: "Search tracks, artists, genres...",
      allGenres: "All Genres",
      allVibes: "All Vibes",
      clearFilters: "Clear",
      tracksFound: "tracks found",
      trackFound: "track found",
      noTracks: "No tracks found matching your criteria",
      bpm: "BPM",
      listenPreview: "Listen Preview",
      buyTrack: "Buy Track",
      licenseTrack: "License Track",
      playlistIncluded: "Playlist Access Included"
    },
    
    // Licenses Section
    licenses: {
      overline: "Licensing Options",
      title: "Choose Your",
      titleHighlight: "License",
      subtitle: "All licenses include commercial use, worldwide rights, and full usage freedom",
      basic: {
        name: "Basic License",
        features: ["Commercial Use Allowed", "Full Usage Freedom", "No Monetization Restrictions", "Worldwide Rights", "Included with Track Purchase"]
      },
      exclusive: {
        name: "Exclusive License",
        features: ["Unlimited Downloads", "Full Access to Tracks", "Commercial Use Allowed", "Worldwide Rights", "Full Usage Control", "Track Removed from Catalog"]
      },
      perTrack: "/track",
      selectLicense: "Select License",
      included: "Included"
    },
    
    // Packs Section
    packs: {
      overline: "Curated Packs",
      title: "Special",
      titleHighlight: "Bundles",
      viewAll: "View All Packs",
      tracks: "Tracks",
      buyPack: "Buy Pack",
      ultimateOverline: "One-Time Offer",
      ultimateName: "OG MUSIC Ultimate Pack",
      ultimateDesc: "Multiple ready-to-release songs with full commercial rights. Includes playlist ecosystem access for curated placement opportunities.",
      ultimateFeatures: [
        "Multiple Ready-to-Release Songs",
        "Instrumental + Vocal Versions",
        "Fully Mastered WAV Files",
        "Organized Folders",
        "Metadata Included",
        "Ready for Distribution",
        "Commercial License Included",
        "Worldwide Rights",
        "Playlist Ecosystem Access"
      ],
      getUltimate: "Get Ultimate Pack"
    },
    
    // Artist Launch System
    artistLaunch: {
      overline: "Premium Product",
      name: "OG MUSIC Artist Launch System",
      description: "Complete artist launch package — 15 songs, full branding, and playlist ecosystem access.",
      features: [
        "15 Complete Songs",
        "Instrumental + Vocal Tracks",
        "Fully Mastered WAV Files",
        "Organized Folders",
        "Metadata Included",
        "Ready for Distribution",
        "Album Cover Design",
        "Artist Image / Branding Style"
      ],
      distribution: "Distribution Process",
      distFeatures: [
        "Distributor matched to your music style",
        "You create your own account & profile",
        "Complete upload & release guide",
        "Catalog management walkthrough",
        "OG MUSIC playlist strategy included"
      ],
      playlistTitle: "Playlist Ecosystem",
      playlistFeatures: [
        "Exposure through OG MUSIC playlists",
        "Visibility across curated collections",
        "Strategic positioning after release",
        "Access to active listener base"
      ],
      cta: "Launch My Artist"
    },
    
    // Membership Section
    membership: {
      overline: "Membership Plans",
      title: "Join the",
      titleHighlight: "OG Family",
      subtitle: "Unlock access to our premium catalog with full commercial rights and worldwide usage",
      perMonth: "/month",
      downloadsPerMonth: "downloads/month",
      unlimited: "Unlimited downloads",
      join: "Join",
      bestValue: "Best Value",
      premium: "Premium",
      tiers: {
        access: {
          name: "OG Access",
          features: ["100 Downloads per month", "Basic License included", "Access to full catalog", "Commercial use allowed", "Worldwide rights", "Cancel anytime"]
        },
        pro: {
          name: "OG Pro",
          features: ["200 Downloads per month", "Commercial License included", "Priority access to new releases", "Exclusive member packs", "Priority support", "Cancel anytime"]
        },
        unlimited: {
          name: "OG Unlimited",
          features: ["Unlimited Downloads", "Commercial License included", "Full catalog access", "Priority support", "Cancel anytime"]
        }
      }
    },
    
    // Promotion Section
    promotion: {
      overline: "Playlist Network",
      title: "Get Your Music",
      titleHighlight: "Heard",
      subtitle: "Leverage our curated playlist ecosystem for strategic visibility. Position your releases in front of the right audience through our network.",
      features: {
        exposure: "Playlist Exposure",
        exposureDesc: "Get your music placed in curated playlists",
        visibility: "Audience Visibility",
        visibilityDesc: "Reach listeners who match your genre",
        positioning: "Strategic Positioning",
        positioningDesc: "Professional placement strategy"
      },
      flow: {
        step1: "Upload your music to streaming platforms",
        step2: "Notify OG MUSIC of your release",
        step3: "Get integrated into curated playlists"
      },
      cta: "Promote My Release",
      note: "Available with $10 tracks, Ultimate Pack, or as standalone service"
    },
    
    // Services Section
    services: {
      overline: "Professional Services",
      title: "Custom",
      titleHighlight: "Solutions",
      production: {
        name: "Music Production",
        desc: "Full music production from scratch, tailored to your vision"
      },
      customTracks: {
        name: "Custom Tracks",
        desc: "Get a track made specifically for your project or brand"
      },
      soundBranding: {
        name: "Sound Branding",
        desc: "Create a unique sonic identity including artist setup and distribution guidance"
      },
      startingAt: "Starting at",
      startProject: "Start a Project"
    },
    
    // Delivery Section
    delivery: {
      overline: "What You Get",
      title: "Ready to Use,",
      titleHighlight: "Ready to Distribute",
      items: {
        wav: { title: "WAV Files", desc: "Fully mastered" },
        mp3: { title: "MP3 Files", desc: "High quality 320kbps" },
        license: { title: "License PDF", desc: "Legal documentation" },
        metadata: { title: "Metadata", desc: "Ready for distribution" }
      }
    },
    
    // Trust Section
    trust: {
      title: "Trusted by",
      titleHighlight: "Creators Worldwide"
    },
    
    // Subscribe Section
    subscribe: {
      title: "Join the OG Universe",
      subtitle: "Get early access to new releases, exclusive packs, and special offers.",
      placeholder: "Enter your email",
      cta: "Subscribe",
      success: "Successfully subscribed!",
      error: "Something went wrong. Please try again."
    },
    
    // News Section
    news: {
      overline: "Latest Updates",
      title: "News &",
      titleHighlight: "Releases",
      readMore: "Read More"
    },
    
    // Footer
    footer: {
      tagline: "A global music ecosystem. Music marketplace, licensing platform, and ready-to-release music provider.",
      music: "Music",
      company: "Company",
      support: "Support",
      about: "About",
      contact: "Contact",
      faq: "FAQ",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      refund: "Refund Policy",
      copyright: "All rights reserved.",
      madeWith: "Made with precision for creators worldwide"
    },
    
    // Auth
    auth: {
      welcomeBack: "Welcome Back",
      signIn: "Sign in to your account",
      createAccount: "Create Account",
      joinCommunity: "Join the OG Music community",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      fullName: "Full Name",
      rememberMe: "Remember me",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset Password",
      resetInstructions: "Enter your email and we'll send you a reset link",
      sendResetLink: "Send Reset Link",
      sending: "Sending...",
      emailSent: "Email Sent!",
      checkInbox: "Check your inbox for the reset link. It expires in 30 minutes.",
      backToLogin: "Back to Login",
      newPassword: "Set New Password",
      enterNewPassword: "Enter your new password below",
      newPasswordLabel: "New Password",
      confirmPasswordLabel: "Confirm Password",
      passwordMinLength: "Password must be at least 8 characters",
      passwordsMustMatch: "Passwords do not match",
      resetPasswordBtn: "Reset Password",
      resetting: "Resetting...",
      passwordUpdated: "Password Updated!",
      redirectingToLogin: "Redirecting to login...",
      goToLogin: "Go to Login",
      invalidResetLink: "Invalid or missing reset link",
      invalidLink: "Invalid Link",
      invalidLinkMessage: "This reset link is invalid or has expired.",
      requestNewLink: "Request a New Link",
      signInBtn: "Sign In",
      signingIn: "Signing in...",
      createBtn: "Create Account",
      creating: "Creating account...",
      noAccount: "Don't have an account?",
      createOne: "Create one",
      haveAccount: "Already have an account?",
      signInLink: "Sign in",
      agreeTerms: "I agree to the",
      and: "and"
    },
    
    // Dashboard
    dashboard: {
      welcomeBack: "Welcome back",
      purchases: "Purchases",
      downloads: "Downloads",
      tracks: "Tracks",
      packs: "Packs",
      purchaseHistory: "Purchase History",
      downloadHistory: "Download History",
      accountSettings: "Account Settings",
      noPurchases: "No purchases yet",
      noDownloads: "No downloads yet",
      browseCatalog: "Browse Catalog",
      billing: "Billing",
      noPaymentMethods: "No payment methods saved",
      manageBilling: "Manage your payment methods",
      addPaymentMethod: "Add Payment Method",
      addAnother: "Add Another",
      setDefault: "Set Default",
      edit: "Edit",
      delete: "Delete",
      paypalEmail: "PayPal Email",
      cryptoCurrency: "Cryptocurrency",
      walletAddress: "Wallet Address (optional)",
      update: "Update",
      save: "Save",
      cancel: "Cancel",
      autoPay: "Auto Pay",
      autoPayDesc: "Automatically charge default method for memberships",
      cardSecureNote: "We only store card brand, last 4 digits, and expiration for reference. Full card data is handled securely by PayPal.",
      cardBrand: "Card Brand",
      lastFour: "Last 4 Digits",
      expiration: "Expiration",
      securitySettings: "Security Settings",
      changeYourPassword: "Change your account password",
      currentPassword: "Current Password",
      newPasswordLabel: "New Password (min 8 characters)",
      confirmNewPassword: "Confirm New Password",
      changePasswordBtn: "Change Password",
      passwordChanged: "Password changed successfully!",
      nameLockedNote: "Name and email are locked after registration. Contact support to request changes.",
      deleteAccount: "Delete Account",
      settings: "Settings",
      orderDetail: "Order Detail",
      orderDate: "Date",
      orderTime: "Time",
      orderId: "Order ID",
      licenseType: "License Type",
      paymentMethod: "Payment Method",
      amount: "Amount",
      status: "Status",
      paid: "Paid",
      downloadMp3: "Download MP3",
      downloadWav: "Download WAV",
      downloadPdf: "Download License",
      downloadPack: "Download Pack",
      noTracks: "No tracks purchased yet",
      noPacks: "No packs purchased yet",
      viewDetails: "View Details",
      back: "Back",
      allFiles: "All Files",
      licensePdf: "License PDF",
      trackName: "Track Name",
      packName: "Pack Name",
      tracksIncluded: "Tracks Included",
      yourTracks: "Your Tracks",
      yourPacks: "Your Packs",
      yourDownloads: "Your Downloads",
      completedOrders: "Completed Orders",
      cardNotAvailable: "Card payments are not currently available for this account.",
      useAlternative: "Please use PayPal or Crypto as your payment method. You can also pay with a card directly at checkout through PayPal.",
      initializingPayPal: "Initializing secure card entry...",
      secureCardNote: "Card data is handled securely by PayPal. We never see or store your full card number or CVV.",
      cardNumber: "Card Number",
      expiryDate: "Expiry Date",
      savingCard: "Saving card...",
      saveCardSecurely: "Save Card Securely via PayPal",
      poweredByPayPal: "Powered by PayPal Secure Card Processing",
      cardSaveError: "Failed to save card. Please check the details and try again.",
      securedViaPayPal: "Secured via PayPal"
    },
    
    // Checkout
    checkout: {
      title: "Checkout",
      orderSummary: "Order Summary",
      purchasingAs: "Purchasing as",
      pleaseSignIn: "Please sign in to complete your purchase",
      paymentMethod: "Payment Method",
      creditCard: "PayPal / Card",
      total: "Total",
      pay: "Pay",
      processing: "Processing...",
      securePayment: "Secure payment powered by PayPal. Your payment information is protected.",
      success: "Payment Successful!",
      successMessage: "Thank you for your purchase. Your download links have been sent to your email.",
      goToDashboard: "Go to Dashboard",
      continueShopping: "Continue Shopping",
      cancelled: "Payment Cancelled",
      cancelledMessage: "Your payment was cancelled. No charges were made to your account.",
      backToHome: "Back to Home"
    },
    
    // Common
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      close: "Close",
      back: "Back",
      next: "Next",
      previous: "Previous",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      all: "All",
      none: "None",
      yes: "Yes",
      no: "No"
    },
    officialPresence: {
      overline: "Official Presence",
      title1: "Real Music. Real Playlists.",
      title2: "Real Audience.",
      description: "OG MUSIC is already live on major platforms. Listen to our music, explore our curated playlists, and verify our real ecosystem with active followers and real activity.",
      badges: ["Music Already Live", "Real Followers", "Active Playlists", "Worldwide Presence"],
      spotifySubtitle: "Official Spotify Profile",
      spotifyDesc: "Explore our curated playlists and discover the sound of the OG MUSIC ecosystem. Real music, real activity, real followers already listening.",
      spotifyFeatures: ["Curated artist playlists", "Genre-specific collections", "New release rotations"],
      spotifyBtn: "Listen on Spotify",
      youtubeSubtitle: "Official YouTube Channel",
      youtubeDesc: "Watch official releases, behind-the-scenes content, and experience the visual side of the OG MUSIC brand on YouTube.",
      youtubeFeatures: ["Official music releases", "Artist showcases", "Brand content & updates"],
      youtubeBtn: "Watch on YouTube",
      trustMessage: "Everything you see is real. Our music is live, our playlists are active, and real people are already listening. Verify it yourself on Spotify and YouTube."
    },
    featuredArtists: {
      overline: "Verified Artists",
      title1: "Real Artists. Real Releases.",
      title2: "Real Platforms.",
      description: "Some artists are already working with OG MUSIC and have their music live across major platforms like Spotify and YouTube. Explore their profiles and experience the quality behind our ecosystem.",
      trustLine: "This is not a concept — it's already happening.",
      bottomText: "Verify the quality, sound, and presence of OG MUSIC artists directly on Spotify.",
      viewAll: "View All Artists"
    },
    artistsPage: {
      overline: "OG MUSIC Ecosystem",
      title1: "Artists Already Trust",
      description: "Real artists. Real releases. Real platforms. Explore the profiles of artists already working within the OG MUSIC ecosystem and hear their music live on Spotify and all major streaming platforms.",
      trustLine: "This is not a concept — it's already happening.",
      ctaTitle1: "Listen to Real Music Already",
      ctaTitle2: "Released",
      ctaDesc: "Every artist shown here has been launched through the OG MUSIC system. Their music is live, positioned in the market, and available for you to verify directly on Spotify.",
      ctaBadges: ["Professional Mastering", "Full Distribution", "Brand Identity", "Playlist Ecosystem"],
      explorePacks: "Explore Music Packs",
      joinMembership: "Join Membership"
    },
    social: {
      followUs: "Follow Us",
      everywhere: "Everywhere"
    },
    howItWorks: {
      overline: "Simple Process",
      title: "How It",
      titleHighlight: "Works",
      subtitle: "From browsing to releasing, in five simple steps.",
      step1: "Choose Your Music",
      step1Desc: "Browse and preview premium tracks",
      step2: "Purchase Instantly",
      step2Desc: "PayPal, card, or crypto",
      step3: "Access Your Panel",
      step3Desc: "Download MP3 + WAV, License & generate your Cover with OG MUSIC",
      step4: "Upload to Distributor",
      step4Desc: "Your preferred distribution platform",
      step5: "Start Growing",
      step5Desc: "Go live on all platforms",
      cta: "Get Your Music Now"
    },
    metrics: {
      tracksAvailable: "Tracks Available",
      tracksReady: "Ready to release",
      activeArtists: "Active Artists",
      onPlatforms: "On real platforms",
      curatedPlaylists: "Curated Playlists",
      spotifyEcosystem: "Spotify ecosystem",
      countriesReached: "Countries Reached",
      globalDistribution: "Global distribution"
    },
    testimonials: {
      overline: "Trusted by Creators",
      title: "Real Music.",
      titleHighlight: "Real Results.",
      quotes: [
        { text: "OG MUSIC made my first release possible. The tracks are professional, the license is clear, and I was live on Spotify within a week.", name: "Carlos M.", role: "Independent Artist" },
        { text: "As a content creator, I needed reliable music with real licenses. OG MUSIC delivers exactly that. Fast, professional, and legit.", name: "Sofia R.", role: "YouTube Creator" },
        { text: "The exclusive license gave me full control. No other artist has my beat. That's exactly what I needed for my brand.", name: "David L.", role: "Recording Artist" }
      ],
      trustBadges: [
        "Artists already working with OG MUSIC",
        "Real music. Real ecosystem.",
        "Trusted by creators worldwide"
      ]
    },
    legal: {
      backToHome: "Back to Home",
      lastUpdated: "Last updated: April 2026",
      termsTitle: "Terms & Conditions",
      termsContent: {
        s1t: "1. Acceptance of Terms",
        s1: "By accessing and using the OG MUSIC GROUP platform (\"Service\"), you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, you should not use our Service. These terms apply to all visitors, users, and purchasers of the platform.",
        s2t: "2. Services Provided",
        s2: "OG MUSIC GROUP provides a digital music marketplace offering: ready-to-release music tracks (MP3 and WAV), commercial music licenses (Basic and Exclusive), music packs and bundles, membership plans with catalog access, and artist launch services. All products are digital goods delivered electronically.",
        s3t: "3. User Accounts",
        s3: "To make purchases, you must create an account with a valid email address. You are responsible for maintaining the confidentiality of your account credentials. You agree to provide accurate, current, and complete information during registration and to update such information as necessary.",
        s4t: "4. Purchases and Payments",
        s4: "All prices are listed in USD. Payments are processed through PayPal (credit/debit cards accepted) and cryptocurrency (USDT TRC20, Bitcoin). Upon successful payment, digital files and licenses are delivered automatically to your registered email address. All sales of digital products are final unless otherwise stated in our Refund Policy.",
        s5t: "5. License Terms",
        s5: "Music purchased through OG MUSIC GROUP comes with a license agreement. The specific terms depend on the license type (Basic or Exclusive). Please review our Licensing Terms page for complete details on permitted uses, restrictions, and rights granted.",
        s6t: "6. Intellectual Property",
        s6: "All content on this platform, including music, artwork, text, and design elements, is the property of OG MUSIC GROUP or its licensors. Purchasing a license grants you specific usage rights as defined in the license agreement but does not transfer ownership of the underlying composition or master recording (except for Exclusive licenses where specified).",
        s7t: "7. Prohibited Uses",
        s7: "You may not: resell, redistribute, or share purchased files in their original form; claim ownership of compositions without an Exclusive license; use the platform for any illegal purpose; attempt to reverse-engineer, hack, or disrupt the Service; create derivative works that infringe on third-party rights.",
        s8t: "8. Limitation of Liability",
        s8: "OG MUSIC GROUP shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use our Service. Our total liability shall not exceed the amount paid by you for the specific product or service giving rise to the claim.",
        s9t: "9. Changes to Terms",
        s9: "We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the Service after changes constitutes acceptance of the modified terms.",
        s10t: "10. Contact",
        s10: "For questions about these Terms & Conditions, contact us at"
      },
      privacyTitle: "Privacy Policy",
      privacyContent: {
        s1t: "1. Information We Collect",
        s1: "We collect information you provide directly: name, email address, and payment information when you create an account or make a purchase. We also collect usage data including pages visited, features used, and device information to improve our Service.",
        s2t: "2. How We Use Your Information",
        s2: "We use your information to: process purchases and deliver digital products, send order confirmations and download links, provide customer support, improve our platform and user experience, send important updates about your account or purchases, and comply with legal obligations.",
        s3t: "3. Payment Processing",
        s3: "Payments are processed through PayPal and cryptocurrency networks. We do not store your full credit card information on our servers. PayPal handles card payment processing according to their own privacy policy and PCI-DSS compliance standards.",
        s4t: "4. Data Sharing",
        s4: "We do not sell, trade, or rent your personal information to third parties. We may share information with: payment processors (PayPal) to complete transactions, email service providers to deliver purchase confirmations, and law enforcement when required by law.",
        s5t: "5. Data Security",
        s5: "We implement industry-standard security measures including encrypted connections (HTTPS), secure authentication (JWT tokens), and protected file storage. However, no method of transmission over the Internet is 100% secure.",
        s6t: "6. Cookies",
        s6: "We use essential cookies for authentication and session management. These are necessary for the platform to function correctly and cannot be disabled without affecting core functionality.",
        s7t: "7. Your Rights",
        s7: "You have the right to: access your personal data, request correction of inaccurate data, request deletion of your account and data, export your purchase history, and opt out of marketing communications. To exercise these rights, contact us at support@ogmusicgroup.com.",
        s8t: "8. Data Retention",
        s8: "We retain your account information and purchase history for as long as your account is active or as needed to provide services. License records are kept indefinitely as proof of purchase. You may request account deletion at any time.",
        s9t: "9. Contact",
        s9: "For privacy-related questions, contact us at"
      },
      refundTitle: "Refund Policy",
      refundContent: {
        s1t: "1. Digital Products Policy",
        s1: "Due to the nature of digital products, all sales are generally final once the download links have been delivered. Digital music files (MP3, WAV) and licenses cannot be \"returned\" once accessed. We encourage you to preview all tracks before purchasing.",
        s2t: "2. When Refunds Are Granted",
        s2: "We will provide a full refund in the following cases: if download links fail and we cannot provide the files within 48 hours, if you were charged multiple times for the same product (duplicate payment), if the delivered files are corrupted or significantly different from what was advertised, or if a technical error on our platform prevented proper delivery.",
        s3t: "3. When Refunds Are Not Granted",
        s3: "Refunds will not be issued for: change of mind after purchase and download, inability to use files due to personal software/hardware limitations, misunderstanding of license terms (please review before purchasing), or purchases made more than 30 days ago.",
        s4t: "4. Membership Refunds",
        s4: "Membership plans can be cancelled at any time. If cancelled within 7 days of purchase and no downloads have been made, a full refund will be issued. After 7 days or if downloads have been made, the membership remains active until the end of the billing period with no refund.",
        s5t: "5. Exclusive License Refunds",
        s5: "Exclusive license purchases are non-refundable once the license has been issued and the track has been removed from the catalog. If you have questions about exclusive licensing, please contact us before purchasing.",
        s6t: "6. How to Request a Refund",
        s6: "To request a refund, contact us at support@ogmusicgroup.com with your order ID, email address used for purchase, and reason for the refund request. We will respond within 48 business hours.",
        s7t: "7. Refund Processing",
        s7: "Approved refunds will be processed through the original payment method (PayPal). Cryptocurrency payments will be refunded to the wallet address provided. Refunds typically take 5-10 business days to appear in your account."
      }
    },
    licensingPage: {
      overline: "Licensing Guide",
      heroTitle: "Music Licensing",
      heroTitleHighlight: "Explained",
      heroSubtitle: "Understand exactly what you can do with music purchased from OG MUSIC GROUP. Clear rights, no confusion.",
      whatYouCanDo: "What You Can Do With Your License",
      cards: [
        { title: "Upload to Platforms", desc: "Spotify, Apple Music, Amazon Music, YouTube Music, Deezer, Tidal, and all major distributors." },
        { title: "Monetize Your Music", desc: "Keep 100% of your streaming revenue, sync fees, and performance royalties." },
        { title: "Commercial Use", desc: "Use in videos, ads, podcasts, social media content, and commercial projects." },
        { title: "Create & Perform", desc: "Record vocals, remix, perform live, and create derivative works." }
      ],
      comparisonTitle: "Basic vs Exclusive License",
      basicName: "Basic License",
      basicIncluded: "Included with every track",
      basicDesc: "Non-exclusive rights — the track remains available for other buyers. Perfect for independent artists, content creators, and small commercial projects.",
      basicFeatures: [
        "Commercial use allowed",
        "Upload to Spotify, Apple Music, YouTube, etc.",
        "Monetization of streams and downloads",
        "Use in videos, ads, and social media",
        "Record vocals and create derivative works",
        "Live performances allowed",
        "Up to 500,000 streams/copies",
        "MP3 + WAV files included",
        "License PDF certificate included"
      ],
      basicLimitations: [
        "Not exclusive — others may license the same track",
        "Credit to OG MUSIC GROUP required"
      ],
      exclusiveName: "Exclusive License",
      exclusiveLabel: "PREMIUM",
      exclusiveIncluded: "Full ownership rights",
      exclusiveDesc: "Exclusive rights — the track is removed from the catalog and belongs only to you. Ideal for professional artists, labels, and major commercial projects.",
      exclusiveFeatures: [
        "Full exclusive rights — track removed from catalog",
        "Unlimited streams and distribution",
        "Upload to all platforms worldwide",
        "Full monetization rights",
        "Use in any commercial project",
        "Modify, remix, and create derivatives",
        "No credit required",
        "MP3 + WAV + Stems (when available)",
        "License PDF certificate included",
        "Perpetual and non-revocable",
        "Priority support included"
      ],
      startingFrom: "Starting from",
      howTitle: "How It Works",
      steps: [
        { title: "Browse & Preview", desc: "Listen to tracks and find your sound" },
        { title: "Choose License", desc: "Basic or Exclusive — your choice" },
        { title: "Purchase Instantly", desc: "PayPal, card, or crypto" },
        { title: "Receive Files", desc: "MP3 + WAV + License PDF by email" },
        { title: "Release & Earn", desc: "Upload to your distributor and go live" }
      ],
      faqTitle: "Common Questions",
      faqs: [
        { q: "Can I upload licensed music to Spotify?", a: "Yes. Both Basic and Exclusive licenses allow you to distribute on Spotify, Apple Music, YouTube Music, and all major platforms." },
        { q: "Can I monetize streams and downloads?", a: "Absolutely. You keep 100% of your streaming revenue and download sales. The license grants you full commercial rights." },
        { q: "What files do I receive?", a: "Every purchase includes MP3 and WAV files, plus a PDF license certificate with your name, order ID, and license terms." },
        { q: "What's the difference between Basic and Exclusive?", a: "Basic is non-exclusive (others can license the same track) with a 500K stream limit. Exclusive gives you sole ownership — the track is removed from the catalog and only you can use it, with no limits." },
        { q: "Can I get a refund?", a: "Digital products are generally non-refundable once delivered. See our Refund Policy for exceptions." }
      ],
      ctaTitle: "Ready to Get Your Music?",
      ctaDesc: "Browse our premium catalog and find your next hit. Every track comes with a commercial license.",
      browseCatalog: "Browse Catalog",
      viewPacks: "View Packs"
    },
    aboutPage: {
      overline: "Our Story",
      title: "About OG MUSIC",
      introDefault: "OG MUSIC GROUP is a complete music ecosystem dedicated to the production, distribution, and licensing of ready-to-release music. We offer mastered tracks, music packs, commercial licenses, and an artist launch system that connects professional sound with the global market.",
      whatWeOffer: "What We Offer",
      offers: [
        { title: "Mastered Tracks", desc: "Professional music ready for commercial projects." },
        { title: "Commercial Licenses", desc: "Clear rights for commercial use with legal documentation." },
        { title: "Memberships", desc: "Unlimited access to the full catalog with flexible plans." },
        { title: "Artist Launch", desc: "Complete system to launch your music career." }
      ],
      visionTitle: "Our Vision",
      visionDefault: "Our vision is to build the most accessible and professional music platform in the world, where every creator can find the perfect sound and every artist can launch their career with real infrastructure.",
      teamTitle: "Our Team & Workflow",
      teamDefault: "A creative and technical team dedicated to producing professional-level music. From our studios, we create, master, and prepare every track for global distribution.",
      teamLabels: ["Music Production", "Creative Studio", "Work Sessions"],
      howTitle: "How We Work",
      howWeWork: [
        { title: "Ready-to-Release Music", desc: "Fully mastered tracks ready for distribution on all digital platforms." },
        { title: "Licensing System", desc: "Clear and legal commercial licenses. Basic and exclusive, with PDF documentation included." },
        { title: "Artist Launch System", desc: "Complete system to launch artists: visual identity, distribution, positioning, and platform presence." },
        { title: "Playlist Ecosystem", desc: "Curated playlist network on Spotify and other platforms to position music and generate real streams." }
      ],
      trustTitle: "Active Music Ecosystem",
      trustElements: [
        "Active music ecosystem",
        "Artists on real platforms",
        "Music ready for global distribution",
        "50+ artists launched",
        "Verified commercial licenses",
        "Presence on Spotify, YouTube & more"
      ],
      exploreCatalog: "Explore Catalog",
      viewArtists: "View Artists",
      founderOverline: "About the Founder"
    },
    faqPage: {
      overline: "FAQ",
      title: "Frequently Asked Questions",
      subtitle: "Find answers to the most common questions about our music, licenses, and platform.",
      empty: "No FAQ items available yet.",
      ctaTitle: "Still have questions?",
      ctaDesc: "Our team is here to help you. Contact us anytime.",
      ctaButton: "Contact Support"
    }
  },
  
  es: {
    // Navigation
    nav: {
      catalog: "Catálogo",
      packs: "Packs",
      licenses: "Licencias",
      membership: "Membresía",
      services: "Servicios",
      artists: "Artistas",
      about: "Sobre Nosotros",
      login: "Iniciar Sesión",
      getStarted: "Comenzar",
      dashboard: "Panel",
      admin: "Admin",
      logout: "Cerrar Sesión"
    },
    
    // Hero Section
    hero: {
      overline: "Ecosistema Musical Global",
      title: "Compra · Descarga ·",
      titleHighlight: "Distribuye",
      subtitle: "Música lista para Distribuir. WAV + MP3 con calidad estudio + portada exclusiva 3000×3000 + licencia certificada — todo se entrega automáticamente al momento de pagar. Ahorra hasta 40% con nuestros packs de 5, 10 o 20 tracks.",
      exploreMusic: "Explorar Música",
      buyPacks: "Comprar Packs",
      joinMembership: "Unirse a Membresía",
      aiPlaceholder: "¿Qué tipo de música necesitas? Yo te ayudo.",
      aiSend: "Enviar",
      aiRecommended: "Recomendados para ti:",
      pillarBuy: "COMPRA MÚSICA LISTA",
      pillarBuyDesc: "97+ tracks masterizados pro. WAV + Portada + Licencia.",
      pillarMaster: "MASTERING CON OG",
      pillarMasterDesc: "Calidad estudio en segundos. 8 presets OG exclusivos. Desde $3.99.",
      tryMastering: "Probar Mastering OG",
    },
    
    // About Founder Section
    founder: {
      overline: "Sobre el Fundador",
      role: "Fundador y Director Creativo",
      name: "Hancel Ovalle",
      headline: "Construyendo un ecosistema musical global impulsado por identidad, sonido y visión.",
      bio: "Como fundador y CEO de OG MUSIC GROUP, Hancel Ovalle ha dedicado su carrera a crear un ecosistema musical escalable que conecta la producción de sonido profesional con la distribución global. Con una visión centrada en la identidad sonora y el posicionamiento estratégico, OG MUSIC GROUP ha crecido hasta convertirse en un catálogo multigénero que sirve a creadores, artistas y empresas en todo el mundo.",
      highlights: {
        vision: "Visión Global",
        visionDesc: "Construyendo infraestructura musical para alcance internacional",
        creative: "Dirección Creativa",
        creativeDesc: "Curando experiencias sonoras premium",
        scalable: "Sistema Escalable",
        scalableDesc: "Música lista para lanzar bajo demanda"
      },
      cta: "Trabajar Con Nosotros",
      ctaSecondary: "Iniciar Proyecto"
    },
    
    // Ecosystem Section
    ecosystem: {
      overline: "El Ecosistema OG",
      title: "Todo lo que Necesitas para",
      titleHighlight: "Lanzar Música",
      subtitle: "Un marketplace musical completo diseñado para lanzamientos profesionales. Desde tracks listos para usar hasta licencias comerciales con derechos mundiales.",
      cards: {
        tracks: { title: "Tracks Premium", desc: "Canciones masterizadas listas para lanzar desde $3 a $10" },
        licensing: { title: "Licencias Claras", desc: "Uso comercial permitido con derechos mundiales" },
        membership: { title: "Membresía", desc: "Descarga hasta canciones ilimitadas mensualmente" },
        promotion: { title: "Promoción", desc: "Ecosistema de playlists para visibilidad y exposición" }
      }
    },
    
    // Catalog Section
    catalog: {
      overline: "Catálogo Musical",
      title: "Tracks",
      titleHighlight: "Destacados",
      viewAll: "Ver Todos los Tracks",
      searchPlaceholder: "Buscar tracks, artistas, géneros...",
      allGenres: "Todos los Géneros",
      allVibes: "Todas las Vibras",
      clearFilters: "Limpiar",
      tracksFound: "tracks encontrados",
      trackFound: "track encontrado",
      noTracks: "No se encontraron tracks con ese criterio",
      bpm: "BPM",
      listenPreview: "Escuchar Preview",
      buyTrack: "Comprar Track",
      licenseTrack: "Licenciar Track",
      playlistIncluded: "Acceso a Playlists Incluido"
    },
    
    // Licenses Section
    licenses: {
      overline: "Opciones de Licencia",
      title: "Elige Tu",
      titleHighlight: "Licencia",
      subtitle: "Todas las licencias incluyen uso comercial, derechos mundiales y libertad total de uso",
      basic: {
        name: "Licencia Básica",
        features: ["Uso Comercial Permitido", "Libertad Total de Uso", "Sin Restricciones de Monetización", "Derechos Mundiales", "Incluida con la Compra del Track"]
      },
      exclusive: {
        name: "Licencia Exclusiva",
        features: ["Descargas Ilimitadas", "Acceso Total a Tracks", "Uso Comercial Permitido", "Derechos Mundiales", "Control Total de Uso", "Track Removido del Catálogo"]
      },
      perTrack: "/track",
      selectLicense: "Seleccionar Licencia",
      included: "Incluida"
    },
    
    // Packs Section
    packs: {
      overline: "Packs Curados",
      title: "Bundles",
      titleHighlight: "Especiales",
      viewAll: "Ver Todos los Packs",
      tracks: "Tracks",
      buyPack: "Comprar Pack",
      ultimateOverline: "Oferta Única",
      ultimateName: "OG MUSIC Ultimate Pack",
      ultimateDesc: "Múltiples canciones listas para lanzar con derechos comerciales completos. Incluye acceso al ecosistema de playlists para oportunidades de colocación curada.",
      ultimateFeatures: [
        "Múltiples Canciones Listas",
        "Versiones Instrumental + Vocal",
        "Archivos WAV Masterizados",
        "Carpetas Organizadas",
        "Metadata Incluida",
        "Listo para Distribución",
        "Licencia Comercial Incluida",
        "Derechos Mundiales",
        "Acceso al Ecosistema de Playlists"
      ],
      getUltimate: "Obtener Ultimate Pack"
    },
    
    // Artist Launch System
    artistLaunch: {
      overline: "Producto Premium",
      name: "Sistema de Lanzamiento de Artista OG MUSIC",
      description: "Paquete completo de lanzamiento — 15 canciones, branding completo, guia de distribucion y acceso al ecosistema de playlists.",
      features: [
        "15 Canciones Completas",
        "Tracks Instrumental + Vocal",
        "Archivos WAV Masterizados",
        "Carpetas Organizadas",
        "Metadata Incluida",
        "Listo para Distribucion",
        "Diseno de Portada de Album",
        "Imagen de Artista / Estilo de Marca"
      ],
      distribution: "Proceso de Distribucion",
      distFeatures: [
        "Distribuidor segun tu estilo musical",
        "Tu creas tu propia cuenta y perfil",
        "Guia completa de subida y lanzamiento",
        "Tutorial de gestion de catalogo",
        "Estrategia de playlists OG MUSIC incluida"
      ],
      playlistTitle: "Ecosistema de Playlists",
      playlistFeatures: [
        "Exposicion en playlists de OG MUSIC",
        "Visibilidad en colecciones curadas",
        "Posicionamiento estrategico post-lanzamiento",
        "Acceso a base de oyentes activos"
      ],
      cta: "Lanzar Mi Artista"
    },
    
    // Membership Section
    membership: {
      overline: "Planes de Membresía",
      title: "Únete a la",
      titleHighlight: "Familia OG",
      subtitle: "Desbloquea acceso a nuestro catálogo premium con derechos comerciales completos y uso mundial",
      perMonth: "/mes",
      downloadsPerMonth: "descargas/mes",
      unlimited: "Descargas ilimitadas",
      join: "Unirse",
      bestValue: "Mejor Valor",
      premium: "Premium",
      tiers: {
        access: {
          name: "OG Access",
          features: ["100 Descargas por mes", "Licencia Básica incluida", "Acceso al catálogo completo", "Uso comercial permitido", "Derechos mundiales", "Cancela cuando quieras"]
        },
        pro: {
          name: "OG Pro",
          features: ["200 Descargas por mes", "Licencia Comercial incluida", "Acceso prioritario a lanzamientos", "Packs exclusivos para miembros", "Soporte prioritario", "Cancela cuando quieras"]
        },
        unlimited: {
          name: "OG Unlimited",
          features: ["Descargas Ilimitadas", "Licencia Comercial incluida", "Acceso completo al catálogo", "Soporte prioritario", "Cancela cuando quieras"]
        }
      }
    },
    
    // Promotion Section
    promotion: {
      overline: "Red de Playlists",
      title: "Que Tu Música",
      titleHighlight: "Sea Escuchada",
      subtitle: "Aprovecha nuestro ecosistema de playlists curado para visibilidad estratégica. Posiciona tus lanzamientos frente a la audiencia correcta.",
      features: {
        exposure: "Exposición en Playlists",
        exposureDesc: "Tu música colocada en playlists curadas",
        visibility: "Visibilidad de Audiencia",
        visibilityDesc: "Alcanza oyentes que coinciden con tu género",
        positioning: "Posicionamiento Estratégico",
        positioningDesc: "Estrategia de colocación profesional"
      },
      flow: {
        step1: "Sube tu música a plataformas de streaming",
        step2: "Notifica a OG MUSIC de tu lanzamiento",
        step3: "Intégrate en playlists curadas"
      },
      cta: "Promocionar Mi Lanzamiento",
      note: "Disponible con tracks de $10, Ultimate Pack, o como servicio independiente"
    },
    
    // Services Section
    services: {
      overline: "Servicios Profesionales",
      title: "Soluciones",
      titleHighlight: "Personalizadas",
      production: {
        name: "Producción Musical",
        desc: "Producción musical completa desde cero, adaptada a tu visión"
      },
      customTracks: {
        name: "Tracks Personalizados",
        desc: "Obtén un track hecho específicamente para tu proyecto o marca"
      },
      soundBranding: {
        name: "Branding Sonoro",
        desc: "Crea una identidad sonora única incluyendo setup de artista profesional"
      },
      startingAt: "Desde",
      startProject: "Iniciar Proyecto"
    },
    
    // Delivery Section
    delivery: {
      overline: "Lo Que Recibes",
      title: "Listo para Usar,",
      titleHighlight: "Listo para Distribuir",
      items: {
        wav: { title: "Archivos WAV", desc: "Completamente masterizados" },
        mp3: { title: "Archivos MP3", desc: "Alta calidad 320kbps" },
        license: { title: "PDF de Licencia", desc: "Documentación legal" },
        metadata: { title: "Metadata", desc: "Listo para distribución" }
      }
    },
    
    // Trust Section
    trust: {
      title: "Confiado por",
      titleHighlight: "Creadores en Todo el Mundo"
    },
    
    // Subscribe Section
    subscribe: {
      title: "Únete al Universo OG",
      subtitle: "Obtén acceso anticipado a nuevos lanzamientos, packs exclusivos y ofertas especiales.",
      placeholder: "Ingresa tu email",
      cta: "Suscribirse",
      success: "¡Suscrito exitosamente!",
      error: "Algo salió mal. Por favor intenta de nuevo."
    },
    
    // News Section
    news: {
      overline: "Últimas Actualizaciones",
      title: "Noticias y",
      titleHighlight: "Lanzamientos",
      readMore: "Leer Más"
    },
    
    // Footer
    footer: {
      tagline: "Un ecosistema musical global. Marketplace musical, plataforma de licencias y proveedor de música lista para lanzar.",
      music: "Música",
      company: "Empresa",
      support: "Soporte",
      about: "Acerca de",
      contact: "Contacto",
      faq: "Preguntas Frecuentes",
      terms: "Términos de Servicio",
      privacy: "Política de Privacidad",
      refund: "Política de Reembolso",
      copyright: "Todos los derechos reservados.",
      madeWith: "Hecho con precisión para creadores en todo el mundo"
    },
    
    // Auth
    auth: {
      welcomeBack: "Bienvenido de Nuevo",
      signIn: "Inicia sesión en tu cuenta",
      createAccount: "Crear Cuenta",
      joinCommunity: "Únete a la comunidad OG Music",
      email: "Email",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      fullName: "Nombre Completo",
      rememberMe: "Recordarme",
      forgotPassword: "¿Olvidaste tu contraseña?",
      resetPassword: "Restablecer Contraseña",
      resetInstructions: "Ingresa tu email y te enviaremos un enlace de restablecimiento",
      sendResetLink: "Enviar Enlace",
      sending: "Enviando...",
      emailSent: "¡Email Enviado!",
      checkInbox: "Revisa tu bandeja de entrada. El enlace expira en 30 minutos.",
      backToLogin: "Volver al Login",
      newPassword: "Nueva Contraseña",
      enterNewPassword: "Ingresa tu nueva contraseña",
      newPasswordLabel: "Nueva Contraseña",
      confirmPasswordLabel: "Confirmar Contraseña",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      passwordsMustMatch: "Las contraseñas no coinciden",
      resetPasswordBtn: "Restablecer Contraseña",
      resetting: "Restableciendo...",
      passwordUpdated: "¡Contraseña Actualizada!",
      redirectingToLogin: "Redirigiendo al login...",
      goToLogin: "Ir al Login",
      invalidResetLink: "Enlace invalido o faltante",
      invalidLink: "Enlace Invalido",
      invalidLinkMessage: "Este enlace ha expirado o es invalido.",
      requestNewLink: "Solicitar Nuevo Enlace",
      signInBtn: "Iniciar Sesión",
      signingIn: "Iniciando sesión...",
      createBtn: "Crear Cuenta",
      creating: "Creando cuenta...",
      noAccount: "¿No tienes cuenta?",
      createOne: "Crear una",
      haveAccount: "¿Ya tienes cuenta?",
      signInLink: "Iniciar sesión",
      agreeTerms: "Acepto los",
      and: "y"
    },
    
    // Dashboard
    dashboard: {
      welcomeBack: "Bienvenido de nuevo",
      purchases: "Compras",
      downloads: "Descargas",
      tracks: "Pistas",
      packs: "Paquetes",
      purchaseHistory: "Historial de Compras",
      downloadHistory: "Historial de Descargas",
      accountSettings: "Configuracion de Cuenta",
      noPurchases: "Sin compras aun",
      noDownloads: "Sin descargas aun",
      browseCatalog: "Explorar Catalogo",
      billing: "Facturacion",
      noPaymentMethods: "Sin metodos de pago guardados",
      manageBilling: "Administra tus metodos de pago",
      addPaymentMethod: "Agregar metodo de pago",
      addAnother: "Agregar otro",
      setDefault: "Establecer como predeterminado",
      edit: "Editar",
      delete: "Eliminar",
      paypalEmail: "Email de PayPal",
      cryptoCurrency: "Criptomoneda",
      walletAddress: "Direccion de wallet (opcional)",
      update: "Actualizar",
      save: "Guardar",
      cancel: "Cancelar",
      autoPay: "Pago Automatico",
      autoPayDesc: "Cobrar automaticamente el metodo predeterminado para membresias",
      cardSecureNote: "Solo almacenamos marca, ultimos 4 digitos y vencimiento. Los datos completos son manejados por PayPal.",
      cardBrand: "Marca de Tarjeta",
      lastFour: "Ultimos 4 Digitos",
      expiration: "Vencimiento",
      securitySettings: "Configuracion de Seguridad",
      changeYourPassword: "Cambia la contraseña de tu cuenta",
      currentPassword: "Contraseña Actual",
      newPasswordLabel: "Nueva Contraseña (min 8 caracteres)",
      confirmNewPassword: "Confirmar Nueva Contraseña",
      changePasswordBtn: "Cambiar Contraseña",
      passwordChanged: "¡Contraseña cambiada exitosamente!",
      nameLockedNote: "El nombre y email estan bloqueados despues del registro. Contacta soporte para solicitar cambios.",
      deleteAccount: "Eliminar Cuenta",
      settings: "Configuracion",
      orderDetail: "Detalle del Pedido",
      orderDate: "Fecha",
      orderTime: "Hora",
      orderId: "ID de Pedido",
      licenseType: "Tipo de Licencia",
      paymentMethod: "Metodo de Pago",
      amount: "Monto",
      status: "Estado",
      paid: "Pagado",
      downloadMp3: "Descargar MP3",
      downloadWav: "Descargar WAV",
      downloadPdf: "Descargar Licencia",
      downloadPack: "Descargar Paquete",
      noTracks: "Sin pistas compradas aun",
      noPacks: "Sin paquetes comprados aun",
      viewDetails: "Ver Detalles",
      back: "Volver",
      allFiles: "Todos los Archivos",
      licensePdf: "Licencia PDF",
      trackName: "Nombre de Pista",
      packName: "Nombre de Paquete",
      tracksIncluded: "Pistas Incluidas",
      yourTracks: "Tus Pistas",
      yourPacks: "Tus Paquetes",
      yourDownloads: "Tus Descargas",
      completedOrders: "Pedidos Completados",
      cardNotAvailable: "Los pagos con tarjeta no están disponibles actualmente para esta cuenta.",
      useAlternative: "Por favor usa PayPal o Crypto como método de pago. También puedes pagar con tarjeta directamente en el checkout a través de PayPal.",
      initializingPayPal: "Inicializando entrada segura de tarjeta...",
      secureCardNote: "Los datos de la tarjeta son manejados de forma segura por PayPal. Nunca vemos ni almacenamos tu número de tarjeta completo o CVV.",
      cardNumber: "Número de Tarjeta",
      expiryDate: "Fecha de Vencimiento",
      savingCard: "Guardando tarjeta...",
      saveCardSecurely: "Guardar Tarjeta de Forma Segura via PayPal",
      poweredByPayPal: "Procesamiento Seguro de Tarjetas por PayPal",
      cardSaveError: "Error al guardar la tarjeta. Por favor verifica los datos e intenta de nuevo.",
      securedViaPayPal: "Asegurado via PayPal"
    },
    
    // Checkout
    checkout: {
      title: "Checkout",
      orderSummary: "Resumen del Pedido",
      purchasingAs: "Comprando como",
      pleaseSignIn: "Por favor inicia sesión para completar tu compra",
      paymentMethod: "Método de Pago",
      creditCard: "PayPal / Tarjeta",
      total: "Total",
      pay: "Pagar",
      processing: "Procesando...",
      securePayment: "Pago seguro con PayPal. Tu información de pago está protegida.",
      success: "¡Pago Exitoso!",
      successMessage: "Gracias por tu compra. Los enlaces de descarga han sido enviados a tu email.",
      goToDashboard: "Ir al Panel",
      continueShopping: "Continuar Comprando",
      cancelled: "Pago Cancelado",
      cancelledMessage: "Tu pago fue cancelado. No se realizaron cargos a tu cuenta.",
      backToHome: "Volver al Inicio"
    },
    
    // Common
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      cancel: "Cancelar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      view: "Ver",
      close: "Cerrar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      search: "Buscar",
      filter: "Filtrar",
      sort: "Ordenar",
      all: "Todo",
      none: "Ninguno",
      yes: "Sí",
      no: "No"
    },
    officialPresence: {
      overline: "Presencia Oficial",
      title1: "Música real. Playlists reales.",
      title2: "Audiencia real.",
      description: "OG MUSIC ya está en las principales plataformas. Escucha nuestra música, explora nuestras playlists curadas y verifica nuestro ecosistema real con seguidores activos y actividad real.",
      badges: ["Música ya en vivo", "Seguidores reales", "Playlists activas", "Presencia mundial"],
      spotifySubtitle: "Perfil Oficial de Spotify",
      spotifyDesc: "Explora nuestras playlists curadas y descubre el sonido del ecosistema OG MUSIC. Música real, actividad real, seguidores reales ya escuchando.",
      spotifyFeatures: ["Playlists de artistas curadas", "Colecciones por género", "Rotaciones de nuevos lanzamientos"],
      spotifyBtn: "Escuchar en Spotify",
      youtubeSubtitle: "Canal Oficial de YouTube",
      youtubeDesc: "Mira lanzamientos oficiales, contenido detrás de cámaras y experimenta el lado visual de la marca OG MUSIC en YouTube.",
      youtubeFeatures: ["Lanzamientos musicales oficiales", "Showcases de artistas", "Contenido de marca y novedades"],
      youtubeBtn: "Ver en YouTube",
      trustMessage: "Todo lo que ves es real. Nuestra música está en vivo, nuestras playlists están activas y personas reales ya están escuchando. Verifícalo tú mismo en Spotify y YouTube."
    },
    featuredArtists: {
      overline: "Artistas Verificados",
      title1: "Artistas reales. Lanzamientos reales.",
      title2: "Plataformas reales.",
      description: "Algunos artistas ya están trabajando con OG MUSIC y tienen su música en las principales plataformas como Spotify y YouTube. Explora sus perfiles y experimenta la calidad detrás de nuestro ecosistema.",
      trustLine: "Esto no es un concepto — ya está sucediendo.",
      bottomText: "Verifica la calidad, el sonido y la presencia de los artistas de OG MUSIC directamente en Spotify.",
      viewAll: "Ver Todos los Artistas"
    },
    artistsPage: {
      overline: "Ecosistema OG MUSIC",
      title1: "Los Artistas ya Confían en",
      description: "Artistas reales. Lanzamientos reales. Plataformas reales. Explora los perfiles de artistas que ya trabajan dentro del ecosistema OG MUSIC y escucha su música en Spotify y todas las plataformas principales.",
      trustLine: "Esto no es un concepto — ya está sucediendo.",
      ctaTitle1: "Escucha Música Real ya",
      ctaTitle2: "Lanzada",
      ctaDesc: "Cada artista mostrado aquí ha sido lanzado a través del sistema OG MUSIC. Su música está en vivo, posicionada en el mercado y disponible para que la verifiques directamente en Spotify.",
      ctaBadges: ["Masterización Profesional", "Distribución Completa", "Identidad de Marca", "Ecosistema de Playlists"],
      explorePacks: "Explorar Packs de Música",
      joinMembership: "Unirse a Membresía"
    },
    // Social / Footer extras
    social: {
      followUs: "Síguenos",
      everywhere: "En Todas Partes"
    },
    // How It Works
    howItWorks: {
      overline: "Proceso Simple",
      title: "Cómo",
      titleHighlight: "Funciona",
      subtitle: "De navegar a lanzar, en cinco simples pasos.",
      step1: "Elige Tu Música",
      step1Desc: "Navega y escucha tracks premium",
      step2: "Compra al Instante",
      step2Desc: "PayPal, tarjeta o cripto",
      step3: "Accede a Tu Panel",
      step3Desc: "Descarga MP3 + WAV, Licencia y genera tu Portada con OG MUSIC",
      step4: "Sube a tu Distribuidor",
      step4Desc: "Tu plataforma de distribución preferida",
      step5: "Empieza a Crecer",
      step5Desc: "Lánzate en todas las plataformas",
      cta: "Obtén Tu Música Ahora"
    },
    // Activity Metrics
    metrics: {
      tracksAvailable: "Tracks Disponibles",
      tracksReady: "Listos para lanzar",
      activeArtists: "Artistas Activos",
      onPlatforms: "En plataformas reales",
      curatedPlaylists: "Playlists Curadas",
      spotifyEcosystem: "Ecosistema Spotify",
      countriesReached: "Países Alcanzados",
      globalDistribution: "Distribución global"
    },
    // Testimonials
    testimonials: {
      overline: "Confiado por Creadores",
      title: "Música Real.",
      titleHighlight: "Resultados Reales.",
      quotes: [
        { text: "OG MUSIC hizo posible mi primer lanzamiento. Los tracks son profesionales, la licencia es clara y estaba en Spotify en una semana.", name: "Carlos M.", role: "Artista Independiente" },
        { text: "Como creadora de contenido, necesitaba música confiable con licencias reales. OG MUSIC entrega exactamente eso. Rápido, profesional y legítimo.", name: "Sofía R.", role: "Creadora de YouTube" },
        { text: "La licencia exclusiva me dio control total. Ningún otro artista tiene mi beat. Eso es exactamente lo que necesitaba para mi marca.", name: "David L.", role: "Artista Musical" }
      ],
      trustBadges: [
        "Artistas ya trabajando con OG MUSIC",
        "Música real. Ecosistema real.",
        "Confiado por creadores en todo el mundo"
      ]
    },
    // Legal pages
    legal: {
      backToHome: "Volver al Inicio",
      lastUpdated: "Última actualización: Abril 2026",
      termsTitle: "Términos y Condiciones",
      termsContent: {
        s1t: "1. Aceptación de los Términos",
        s1: "Al acceder y utilizar la plataforma OG MUSIC GROUP (\"Servicio\"), usted acepta y se compromete a cumplir con estos Términos y Condiciones. Si no está de acuerdo con estos términos, no debe utilizar nuestro Servicio. Estos términos se aplican a todos los visitantes, usuarios y compradores de la plataforma.",
        s2t: "2. Servicios Proporcionados",
        s2: "OG MUSIC GROUP proporciona un marketplace de música digital que ofrece: tracks de música listos para lanzar (MP3 y WAV), licencias musicales comerciales (Básica y Exclusiva), packs y bundles musicales, planes de membresía con acceso al catálogo y servicios de lanzamiento de artistas. Todos los productos son bienes digitales entregados electrónicamente.",
        s3t: "3. Cuentas de Usuario",
        s3: "Para realizar compras, debe crear una cuenta con una dirección de email válida. Usted es responsable de mantener la confidencialidad de sus credenciales de cuenta. Se compromete a proporcionar información precisa, actual y completa durante el registro y a actualizar dicha información según sea necesario.",
        s4t: "4. Compras y Pagos",
        s4: "Todos los precios están en USD. Los pagos se procesan a través de PayPal (se aceptan tarjetas de crédito/débito) y criptomonedas (USDT TRC20, Bitcoin). Tras el pago exitoso, los archivos digitales y licencias se entregan automáticamente a su dirección de email registrada. Todas las ventas de productos digitales son finales a menos que se indique lo contrario en nuestra Política de Reembolso.",
        s5t: "5. Términos de Licencia",
        s5: "La música comprada a través de OG MUSIC GROUP viene con un acuerdo de licencia. Los términos específicos dependen del tipo de licencia (Básica o Exclusiva). Consulte nuestra página de Términos de Licencia para obtener detalles completos sobre los usos permitidos, restricciones y derechos otorgados.",
        s6t: "6. Propiedad Intelectual",
        s6: "Todo el contenido de esta plataforma, incluyendo música, arte, texto y elementos de diseño, es propiedad de OG MUSIC GROUP o sus licenciantes. La compra de una licencia le otorga derechos de uso específicos según lo definido en el acuerdo de licencia, pero no transfiere la propiedad de la composición subyacente o grabación master (excepto para licencias Exclusivas donde se especifique).",
        s7t: "7. Usos Prohibidos",
        s7: "No puede: revender, redistribuir o compartir archivos comprados en su forma original; reclamar la propiedad de composiciones sin una licencia Exclusiva; usar la plataforma para cualquier propósito ilegal; intentar realizar ingeniería inversa, hackear o interrumpir el Servicio; crear obras derivadas que infrinjan los derechos de terceros.",
        s8t: "8. Limitación de Responsabilidad",
        s8: "OG MUSIC GROUP no será responsable de daños indirectos, incidentales, especiales o consecuentes que resulten del uso o la imposibilidad de usar nuestro Servicio. Nuestra responsabilidad total no excederá el monto pagado por usted por el producto o servicio específico que da lugar a la reclamación.",
        s9t: "9. Cambios en los Términos",
        s9: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos inmediatamente después de su publicación. Su uso continuado del Servicio después de los cambios constituye la aceptación de los términos modificados.",
        s10t: "10. Contacto",
        s10: "Para preguntas sobre estos Términos y Condiciones, contáctenos en"
      },
      privacyTitle: "Política de Privacidad",
      privacyContent: {
        s1t: "1. Información que Recopilamos",
        s1: "Recopilamos información que usted proporciona directamente: nombre, dirección de email e información de pago cuando crea una cuenta o realiza una compra. También recopilamos datos de uso, incluyendo páginas visitadas, funciones utilizadas e información del dispositivo para mejorar nuestro Servicio.",
        s2t: "2. Cómo Usamos su Información",
        s2: "Usamos su información para: procesar compras y entregar productos digitales, enviar confirmaciones de pedido y enlaces de descarga, proporcionar soporte al cliente, mejorar nuestra plataforma y experiencia de usuario, enviar actualizaciones importantes sobre su cuenta o compras y cumplir con obligaciones legales.",
        s3t: "3. Procesamiento de Pagos",
        s3: "Los pagos se procesan a través de PayPal y redes de criptomonedas. No almacenamos la información completa de su tarjeta de crédito en nuestros servidores. PayPal maneja el procesamiento de pagos con tarjeta de acuerdo con su propia política de privacidad y estándares PCI-DSS.",
        s4t: "4. Compartir Datos",
        s4: "No vendemos, comerciamos ni alquilamos su información personal a terceros. Podemos compartir información con: procesadores de pago (PayPal) para completar transacciones, proveedores de servicios de email para entregar confirmaciones de compra y autoridades legales cuando lo exija la ley.",
        s5t: "5. Seguridad de Datos",
        s5: "Implementamos medidas de seguridad estándar de la industria, incluyendo conexiones encriptadas (HTTPS), autenticación segura (tokens JWT) y almacenamiento protegido de archivos. Sin embargo, ningún método de transmisión por Internet es 100% seguro.",
        s6t: "6. Cookies",
        s6: "Usamos cookies esenciales para autenticación y gestión de sesiones. Estas son necesarias para que la plataforma funcione correctamente y no pueden desactivarse sin afectar la funcionalidad básica.",
        s7t: "7. Sus Derechos",
        s7: "Usted tiene derecho a: acceder a sus datos personales, solicitar la corrección de datos inexactos, solicitar la eliminación de su cuenta y datos, exportar su historial de compras y optar por no recibir comunicaciones de marketing. Para ejercer estos derechos, contáctenos en support@ogmusicgroup.com.",
        s8t: "8. Retención de Datos",
        s8: "Retenemos la información de su cuenta e historial de compras mientras su cuenta esté activa o según sea necesario para proporcionar servicios. Los registros de licencia se mantienen indefinidamente como prueba de compra. Puede solicitar la eliminación de su cuenta en cualquier momento.",
        s9t: "9. Contacto",
        s9: "Para preguntas relacionadas con la privacidad, contáctenos en"
      },
      refundTitle: "Política de Reembolso",
      refundContent: {
        s1t: "1. Política de Productos Digitales",
        s1: "Debido a la naturaleza de los productos digitales, todas las ventas son generalmente finales una vez que los enlaces de descarga han sido entregados. Los archivos de música digital (MP3, WAV) y las licencias no pueden ser \"devueltos\" una vez accedidos. Le recomendamos escuchar todos los tracks antes de comprar.",
        s2t: "2. Cuándo se Otorgan Reembolsos",
        s2: "Proporcionaremos un reembolso completo en los siguientes casos: si los enlaces de descarga fallan y no podemos proporcionar los archivos en 48 horas, si se le cobró varias veces por el mismo producto (pago duplicado), si los archivos entregados están corruptos o son significativamente diferentes de lo anunciado, o si un error técnico en nuestra plataforma impidió la entrega adecuada.",
        s3t: "3. Cuándo No se Otorgan Reembolsos",
        s3: "No se emitirán reembolsos por: cambio de opinión después de la compra y descarga, incapacidad de usar archivos debido a limitaciones personales de software/hardware, malentendido de los términos de licencia (revise antes de comprar) o compras realizadas hace más de 30 días.",
        s4t: "4. Reembolsos de Membresía",
        s4: "Los planes de membresía se pueden cancelar en cualquier momento. Si se cancela dentro de los 7 días posteriores a la compra y no se han realizado descargas, se emitirá un reembolso completo. Después de 7 días o si se han realizado descargas, la membresía permanece activa hasta el final del período de facturación sin reembolso.",
        s5t: "5. Reembolsos de Licencia Exclusiva",
        s5: "Las compras de licencias exclusivas no son reembolsables una vez que la licencia ha sido emitida y el track ha sido removido del catálogo. Si tiene preguntas sobre licencias exclusivas, contáctenos antes de comprar.",
        s6t: "6. Cómo Solicitar un Reembolso",
        s6: "Para solicitar un reembolso, contáctenos en support@ogmusicgroup.com con su ID de pedido, dirección de email utilizada para la compra y motivo de la solicitud de reembolso. Responderemos dentro de las 48 horas hábiles.",
        s7t: "7. Procesamiento de Reembolsos",
        s7: "Los reembolsos aprobados se procesarán a través del método de pago original (PayPal). Los pagos en criptomonedas se reembolsarán a la dirección de wallet proporcionada. Los reembolsos generalmente tardan de 5 a 10 días hábiles en aparecer en su cuenta."
      }
    },
    licensingPage: {
      overline: "Guía de Licencias",
      heroTitle: "Licencias Musicales",
      heroTitleHighlight: "Explicadas",
      heroSubtitle: "Entiende exactamente qué puedes hacer con la música comprada en OG MUSIC GROUP. Derechos claros, sin confusión.",
      whatYouCanDo: "Qué Puedes Hacer con Tu Licencia",
      cards: [
        { title: "Subir a Plataformas", desc: "Spotify, Apple Music, Amazon Music, YouTube Music, Deezer, Tidal y todos los distribuidores principales." },
        { title: "Monetizar Tu Música", desc: "Conserva el 100% de tus ingresos por streaming, tarifas de sincronización y regalías." },
        { title: "Uso Comercial", desc: "Usa en videos, anuncios, podcasts, contenido en redes sociales y proyectos comerciales." },
        { title: "Crear e Interpretar", desc: "Graba vocales, remezcla, presenta en vivo y crea obras derivadas." }
      ],
      comparisonTitle: "Licencia Básica vs Exclusiva",
      basicName: "Licencia Básica",
      basicIncluded: "Incluida con cada track",
      basicDesc: "Derechos no exclusivos — el track permanece disponible para otros compradores. Perfecto para artistas independientes, creadores de contenido y proyectos comerciales pequeños.",
      basicFeatures: [
        "Uso comercial permitido",
        "Subir a Spotify, Apple Music, YouTube, etc.",
        "Monetización de streams y descargas",
        "Uso en videos, anuncios y redes sociales",
        "Grabar vocales y crear obras derivadas",
        "Presentaciones en vivo permitidas",
        "Hasta 500,000 reproducciones/copias",
        "Archivos MP3 + WAV incluidos",
        "Certificado de licencia PDF incluido"
      ],
      basicLimitations: [
        "No exclusiva — otros pueden licenciar el mismo track",
        "Se requiere crédito a OG MUSIC GROUP"
      ],
      exclusiveName: "Licencia Exclusiva",
      exclusiveLabel: "PREMIUM",
      exclusiveIncluded: "Derechos de propiedad total",
      exclusiveDesc: "Derechos exclusivos — el track se elimina del catálogo y te pertenece solo a ti. Ideal para artistas profesionales, sellos y grandes proyectos comerciales.",
      exclusiveFeatures: [
        "Derechos exclusivos completos — track eliminado del catálogo",
        "Streams y distribución ilimitados",
        "Subir a todas las plataformas mundiales",
        "Derechos completos de monetización",
        "Uso en cualquier proyecto comercial",
        "Modificar, remezclar y crear derivados",
        "No se requiere crédito",
        "MP3 + WAV + Stems (cuando disponible)",
        "Certificado de licencia PDF incluido",
        "Perpetua y no revocable",
        "Soporte prioritario incluido"
      ],
      startingFrom: "Desde",
      howTitle: "Cómo Funciona",
      steps: [
        { title: "Navega y Escucha", desc: "Escucha los tracks y encuentra tu sonido" },
        { title: "Elige Licencia", desc: "Básica o Exclusiva — tu elección" },
        { title: "Compra al Instante", desc: "PayPal, tarjeta o cripto" },
        { title: "Recibe Archivos", desc: "MP3 + WAV + Licencia PDF por email" },
        { title: "Lanza y Gana", desc: "Sube a tu distribuidor y lánzate" }
      ],
      faqTitle: "Preguntas Frecuentes",
      faqs: [
        { q: "¿Puedo subir música licenciada a Spotify?", a: "Sí. Tanto la licencia Básica como la Exclusiva te permiten distribuir en Spotify, Apple Music, YouTube Music y todas las plataformas principales." },
        { q: "¿Puedo monetizar streams y descargas?", a: "Por supuesto. Conservas el 100% de tus ingresos por streaming y ventas de descargas. La licencia te otorga derechos comerciales completos." },
        { q: "¿Qué archivos recibo?", a: "Cada compra incluye archivos MP3 y WAV, más un certificado de licencia PDF con tu nombre, ID de pedido y términos de la licencia." },
        { q: "¿Cuál es la diferencia entre Básica y Exclusiva?", a: "La Básica no es exclusiva (otros pueden licenciar el mismo track) con un límite de 500K reproducciones. La Exclusiva te da propiedad total — el track se elimina del catálogo y solo tú puedes usarlo, sin límites." },
        { q: "¿Puedo obtener un reembolso?", a: "Los productos digitales generalmente no son reembolsables una vez entregados. Consulta nuestra Política de Reembolso para excepciones." }
      ],
      ctaTitle: "¿Listo para Obtener Tu Música?",
      ctaDesc: "Explora nuestro catálogo premium y encuentra tu próximo éxito. Cada track incluye una licencia comercial.",
      browseCatalog: "Explorar Catálogo",
      viewPacks: "Ver Packs"
    },
    aboutPage: {
      overline: "Nuestra Historia",
      title: "Sobre OG MUSIC",
      introDefault: "OG MUSIC GROUP es un ecosistema musical completo dedicado a la producción, distribución y licenciamiento de música lista para lanzar. Ofrecemos tracks masterizados, packs musicales, licencias comerciales y un sistema de lanzamiento de artistas que conecta el sonido profesional con el mercado global.",
      whatWeOffer: "Lo Que Ofrecemos",
      offers: [
        { title: "Tracks Masterizados", desc: "Música profesional lista para usar en proyectos comerciales." },
        { title: "Licencias Comerciales", desc: "Derechos claros para uso comercial con documentación legal." },
        { title: "Membresías", desc: "Acceso ilimitado a catálogo completo con planes flexibles." },
        { title: "Lanzamiento de Artistas", desc: "Sistema completo para lanzar tu carrera musical." }
      ],
      visionTitle: "Nuestra Visión",
      visionDefault: "Nuestra visión es construir la plataforma musical más accesible y profesional del mundo, donde cada creador pueda encontrar el sonido perfecto para su proyecto y cada artista pueda lanzar su carrera con infraestructura real.",
      teamTitle: "Nuestro Equipo de Trabajo",
      teamDefault: "Un equipo creativo y técnico dedicado a producir música de nivel profesional. Desde nuestros estudios, creamos, masterizamos y preparamos cada track para distribución global.",
      teamLabels: ["Producción Musical", "Estudio Creativo", "Sesiones de Trabajo"],
      howTitle: "Cómo Trabajamos",
      howWeWork: [
        { title: "Música Lista para Lanzar", desc: "Tracks completamente masterizados y listos para distribución en todas las plataformas digitales." },
        { title: "Sistema de Licencias", desc: "Licencias comerciales claras y legales. Básica y exclusiva, con documentación PDF incluida." },
        { title: "Lanzamiento de Artistas", desc: "Sistema completo para lanzar artistas: identidad visual, distribución, posicionamiento y presencia en plataformas." },
        { title: "Ecosistema de Playlists", desc: "Red de playlists curadas en Spotify y otras plataformas para posicionar música y generar streams reales." }
      ],
      trustTitle: "Ecosistema Musical Activo",
      trustElements: [
        "Ecosistema musical activo",
        "Artistas en plataformas reales",
        "Música lista para distribución global",
        "+50 artistas lanzados",
        "Licencias comerciales verificadas",
        "Presencia en Spotify, YouTube y más"
      ],
      exploreCatalog: "Explorar Catálogo",
      viewArtists: "Ver Artistas",
      founderOverline: "Sobre el Fundador"
    },
    faqPage: {
      overline: "Preguntas Frecuentes",
      title: "Preguntas Frecuentes",
      subtitle: "Encuentra respuestas a las preguntas más comunes sobre nuestra música, licencias y plataforma.",
      empty: "Aún no hay preguntas frecuentes disponibles.",
      ctaTitle: "¿Aún tienes preguntas?",
      ctaDesc: "Nuestro equipo está aquí para ayudarte. Contáctanos en cualquier momento.",
      ctaButton: "Contactar Soporte"
    }
  },
  
  pt: {
    // Navigation
    nav: {
      catalog: "Catálogo",
      packs: "Packs",
      licenses: "Licenças",
      membership: "Assinatura",
      services: "Serviços",
      artists: "Artistas",
      about: "Sobre Nós",
      login: "Entrar",
      getStarted: "Começar",
      dashboard: "Painel",
      admin: "Admin",
      logout: "Sair"
    },
    
    // Hero Section
    hero: {
      overline: "Ecossistema Musical Global",
      title: "Compre · Baixe ·",
      titleHighlight: "Distribua",
      subtitle: "Música pronta para lançar. WAV + MP3 qualidade studio + capa exclusiva 3000×3000 + licença certificada — tudo entregue automaticamente após o pagamento. Economize até 40% com nossos packs de 5, 10 ou 20 tracks.",
      exploreMusic: "Explorar Música",
      buyPacks: "Comprar Packs",
      joinMembership: "Assinar",
      pillarBuy: "COMPRE MÚSICA PRONTA",
      pillarBuyDesc: "97+ tracks masterizados pro. WAV + Capa + Licença.",
      pillarMaster: "MASTERIZAÇÃO OG",
      pillarMasterDesc: "Qualidade studio em segundos. 8 presets OG exclusivos. Desde $3.99.",
      tryMastering: "Testar Mastering OG",
    },
    
    // About Founder Section
    founder: {
      overline: "Sobre o Fundador",
      role: "Fundador e Diretor Criativo",
      name: "Hancel Ovalle",
      headline: "Construindo um ecossistema musical global impulsionado por identidade, som e visão.",
      bio: "Como fundador e CEO do OG MUSIC GROUP, Hancel Ovalle dedicou sua carreira a criar um ecossistema musical escalável que conecta a produção de som profissional com a distribuição global.",
      highlights: {
        vision: "Visão Global",
        visionDesc: "Construindo infraestrutura musical para alcance internacional",
        creative: "Direção Criativa",
        creativeDesc: "Curando experiências sonoras premium",
        scalable: "Sistema Escalável",
        scalableDesc: "Música pronta para lançar sob demanda"
      },
      cta: "Trabalhar Conosco",
      ctaSecondary: "Iniciar Projeto"
    },
    
    // Ecosystem Section
    ecosystem: {
      overline: "O Ecossistema OG",
      title: "Tudo que Você Precisa para",
      titleHighlight: "Lançar Música",
      subtitle: "Um marketplace musical completo projetado para lançamentos profissionais.",
      cards: {
        tracks: { title: "Faixas Premium", desc: "Músicas masterizadas de $3 a $10" },
        licensing: { title: "Licenças Claras", desc: "Uso comercial com direitos mundiais" },
        membership: { title: "Assinatura", desc: "Downloads ilimitados mensalmente" },
        promotion: { title: "Promoção", desc: "Ecossistema de playlists para visibilidade" }
      }
    },
    
    // Catalog Section
    catalog: {
      overline: "Catálogo Musical",
      title: "Faixas",
      titleHighlight: "Destacadas",
      viewAll: "Ver Todas",
      searchPlaceholder: "Buscar faixas, artistas, gêneros...",
      allGenres: "Todos os Gêneros",
      allVibes: "Todas as Vibes",
      clearFilters: "Limpar",
      tracksFound: "faixas encontradas",
      trackFound: "faixa encontrada",
      noTracks: "Nenhuma faixa encontrada",
      bpm: "BPM",
      listenPreview: "Ouvir Preview",
      buyTrack: "Comprar Faixa",
      licenseTrack: "Licenciar Faixa",
      playlistIncluded: "Acesso a Playlists Incluído"
    },
    
    // Licenses Section
    licenses: {
      overline: "Opções de Licença",
      title: "Escolha Sua",
      titleHighlight: "Licença",
      subtitle: "Todas as licenças incluem uso comercial, direitos mundiais e liberdade total",
      basic: {
        name: "Licença Básica",
        features: ["Uso Comercial Permitido", "Liberdade Total de Uso", "Sem Restrições", "Direitos Mundiais", "Incluída na Compra"]
      },
      exclusive: {
        name: "Licença Exclusiva",
        features: ["Downloads Ilimitados", "Acesso Total", "Uso Comercial", "Direitos Mundiais", "Controle Total", "Faixa Removida"]
      },
      perTrack: "/faixa",
      selectLicense: "Selecionar",
      included: "Incluída"
    },
    
    // Packs Section
    packs: {
      overline: "Packs Curados",
      title: "Bundles",
      titleHighlight: "Especiais",
      viewAll: "Ver Todos",
      tracks: "Faixas",
      buyPack: "Comprar Pack",
      ultimateOverline: "Oferta Única",
      ultimateName: "OG MUSIC Ultimate Pack",
      ultimateDesc: "Múltiplas músicas prontas com direitos comerciais. Inclui acesso ao ecossistema de playlists.",
      ultimateFeatures: [
        "Múltiplas Músicas Prontas",
        "Versões Instrumental + Vocal",
        "Arquivos WAV Masterizados",
        "Pastas Organizadas",
        "Metadata Incluída",
        "Pronto para Distribuição",
        "Licença Comercial",
        "Direitos Mundiais",
        "Acesso a Playlists"
      ],
      getUltimate: "Obter Ultimate Pack"
    },
    
    // Artist Launch System
    artistLaunch: {
      overline: "Produto Premium",
      name: "Sistema de Lancamento de Artista OG MUSIC",
      description: "Pacote completo de lancamento — 15 musicas, branding completo, guia de distribuicao e acesso ao ecossistema de playlists.",
      features: [
        "15 Musicas Completas",
        "Faixas Instrumental + Vocal",
        "Arquivos WAV Masterizados",
        "Pastas Organizadas",
        "Metadata Incluida",
        "Pronto para Distribuicao",
        "Design de Capa de Album",
        "Imagem de Artista / Estilo de Marca"
      ],
      distribution: "Processo de Distribuicao",
      distFeatures: [
        "Distribuidor adequado ao seu estilo musical",
        "Voce cria sua propria conta e perfil",
        "Guia completo de upload e lancamento",
        "Tutorial de gestao de catalogo",
        "Estrategia de playlists OG MUSIC incluida"
      ],
      playlistTitle: "Ecossistema de Playlists",
      playlistFeatures: [
        "Exposicao em playlists da OG MUSIC",
        "Visibilidade em colecoes curadas",
        "Posicionamento estrategico pos-lancamento",
        "Acesso a base de ouvintes ativos"
      ],
      cta: "Lancar Meu Artista"
    },
    
    // Membership Section
    membership: {
      overline: "Planos de Assinatura",
      title: "Junte-se à",
      titleHighlight: "Família OG",
      subtitle: "Acesso ao catálogo com direitos comerciais e uso mundial",
      perMonth: "/mês",
      downloadsPerMonth: "downloads/mês",
      unlimited: "Downloads ilimitados",
      join: "Assinar",
      bestValue: "Melhor Valor",
      premium: "Premium",
      tiers: {
        access: {
          name: "OG Access",
          features: ["100 Downloads por mês", "Licença Básica", "Acesso ao catálogo", "Uso comercial", "Direitos mundiais", "Cancele quando quiser"]
        },
        pro: {
          name: "OG Pro",
          features: ["200 Downloads por mês", "Licença Comercial", "Acesso prioritário", "Packs exclusivos", "Suporte prioritário", "Cancele quando quiser"]
        },
        unlimited: {
          name: "OG Unlimited",
          features: ["Downloads Ilimitados", "Licença Comercial", "Acesso total", "Suporte prioritário", "Cancele quando quiser"]
        }
      }
    },
    
    // Promotion Section
    promotion: {
      overline: "Rede de Playlists",
      title: "Sua Música",
      titleHighlight: "Ouvida",
      subtitle: "Aproveite nosso ecossistema de playlists para visibilidade estratégica.",
      features: {
        exposure: "Exposição em Playlists",
        exposureDesc: "Sua música em playlists curadas",
        visibility: "Visibilidade",
        visibilityDesc: "Alcance ouvintes do seu gênero",
        positioning: "Posicionamento",
        positioningDesc: "Estratégia profissional"
      },
      flow: {
        step1: "Suba sua música nas plataformas",
        step2: "Notifique o OG MUSIC",
        step3: "Integre-se às playlists"
      },
      cta: "Promover Lançamento",
      note: "Disponível com faixas de $10, Ultimate Pack, ou serviço avulso"
    },
    
    // Services Section
    services: {
      overline: "Serviços Profissionais",
      title: "Soluções",
      titleHighlight: "Personalizadas",
      production: { name: "Produção Musical", desc: "Produção completa do zero" },
      customTracks: { name: "Faixas Personalizadas", desc: "Faixa feita para seu projeto" },
      soundBranding: { name: "Branding Sonoro", desc: "Identidade sonora com setup de artista" },
      startingAt: "A partir de",
      startProject: "Iniciar Projeto"
    },
    
    // Delivery Section
    delivery: {
      overline: "O que Você Recebe",
      title: "Pronto para Usar,",
      titleHighlight: "Pronto para Distribuir",
      items: {
        wav: { title: "Arquivos WAV", desc: "Masterizados" },
        mp3: { title: "Arquivos MP3", desc: "320kbps" },
        license: { title: "PDF da Licença", desc: "Documentação" },
        metadata: { title: "Metadata", desc: "Para distribuição" }
      }
    },
    
    // Trust Section
    trust: {
      title: "Confiado por",
      titleHighlight: "Criadores no Mundo Todo"
    },
    
    // Subscribe Section
    subscribe: {
      title: "Junte-se ao Universo OG",
      subtitle: "Acesso antecipado a lançamentos e packs exclusivos.",
      placeholder: "Seu email",
      cta: "Inscrever",
      success: "Inscrito com sucesso!",
      error: "Algo deu errado."
    },
    
    // News Section
    news: {
      overline: "Atualizações",
      title: "Notícias e",
      titleHighlight: "Lançamentos",
      readMore: "Ler Mais"
    },
    
    // Footer
    footer: {
      tagline: "Ecossistema musical global. Marketplace, plataforma de licenças e provedor de música pronta.",
      music: "Música",
      company: "Empresa",
      support: "Suporte",
      about: "Sobre",
      contact: "Contato",
      faq: "FAQ",
      terms: "Termos",
      privacy: "Privacidade",
      refund: "Reembolso",
      copyright: "Todos os direitos reservados.",
      madeWith: "Feito para criadores no mundo todo"
    },
    
    auth: {
      welcomeBack: "Bem-vindo de Volta",
      signIn: "Entre na sua conta",
      createAccount: "Criar Conta",
      joinCommunity: "Junte-se à comunidade OG Music",
      email: "Email",
      password: "Senha",
      confirmPassword: "Confirmar Senha",
      fullName: "Nome Completo",
      rememberMe: "Lembrar",
      forgotPassword: "Esqueceu a senha?",
      resetPassword: "Redefinir Senha",
      resetInstructions: "Digite seu email e enviaremos um link de redefinicao",
      sendResetLink: "Enviar Link",
      sending: "Enviando...",
      emailSent: "Email Enviado!",
      checkInbox: "Verifique sua caixa de entrada. O link expira em 30 minutos.",
      backToLogin: "Voltar ao Login",
      newPassword: "Nova Senha",
      enterNewPassword: "Digite sua nova senha",
      newPasswordLabel: "Nova Senha",
      confirmPasswordLabel: "Confirmar Senha",
      passwordMinLength: "A senha deve ter pelo menos 8 caracteres",
      passwordsMustMatch: "As senhas nao coincidem",
      resetPasswordBtn: "Redefinir Senha",
      resetting: "Redefinindo...",
      passwordUpdated: "Senha Atualizada!",
      redirectingToLogin: "Redirecionando ao login...",
      goToLogin: "Ir ao Login",
      invalidResetLink: "Link invalido ou ausente",
      invalidLink: "Link Invalido",
      invalidLinkMessage: "Este link expirou ou e invalido.",
      requestNewLink: "Solicitar Novo Link",
      signInBtn: "Entrar",
      signingIn: "Entrando...",
      createBtn: "Criar Conta",
      creating: "Criando...",
      noAccount: "Não tem conta?",
      createOne: "Criar uma",
      haveAccount: "Já tem conta?",
      signInLink: "Entrar",
      agreeTerms: "Aceito os",
      and: "e"
    },
    
    dashboard: {
      welcomeBack: "Bem-vindo",
      purchases: "Compras",
      downloads: "Downloads",
      tracks: "Faixas",
      packs: "Packs",
      purchaseHistory: "Historico de Compras",
      downloadHistory: "Historico de Downloads",
      accountSettings: "Configuracoes",
      noPurchases: "Sem compras",
      noDownloads: "Sem downloads",
      browseCatalog: "Ver Catalogo",
      billing: "Cobranca",
      noPaymentMethods: "Sem metodos de pagamento",
      manageBilling: "Gerencie seus metodos de pagamento",
      addPaymentMethod: "Adicionar metodo de pagamento",
      addAnother: "Adicionar outro",
      setDefault: "Definir como padrao",
      edit: "Editar",
      delete: "Excluir",
      paypalEmail: "Email do PayPal",
      cryptoCurrency: "Criptomoeda",
      walletAddress: "Endereco da carteira (opcional)",
      update: "Atualizar",
      save: "Salvar",
      cancel: "Cancelar",
      securitySettings: "Configuracoes de Seguranca",
      changeYourPassword: "Altere a senha da sua conta",
      currentPassword: "Senha Atual",
      newPasswordLabel: "Nova Senha (min 8 caracteres)",
      confirmNewPassword: "Confirmar Nova Senha",
      changePasswordBtn: "Alterar Senha",
      passwordChanged: "Senha alterada com sucesso!",
      nameLockedNote: "Nome e email sao bloqueados apos o registro. Contate o suporte para solicitar alteracoes.",
      deleteAccount: "Excluir Conta",
      settings: "Configuracoes",
      orderDetail: "Detalhe do Pedido",
      orderDate: "Data",
      orderTime: "Hora",
      orderId: "ID do Pedido",
      licenseType: "Tipo de Licenca",
      paymentMethod: "Metodo de Pagamento",
      amount: "Valor",
      status: "Status",
      paid: "Pago",
      downloadMp3: "Baixar MP3",
      downloadWav: "Baixar WAV",
      downloadPdf: "Baixar Licenca",
      downloadPack: "Baixar Pacote",
      noTracks: "Sem faixas compradas",
      noPacks: "Sem packs comprados",
      viewDetails: "Ver Detalhes",
      back: "Voltar",
      allFiles: "Todos os Arquivos",
      licensePdf: "Licenca PDF",
      trackName: "Nome da Faixa",
      packName: "Nome do Pack",
      tracksIncluded: "Faixas Incluidas",
      yourTracks: "Suas Faixas",
      yourPacks: "Seus Packs",
      yourDownloads: "Seus Downloads",
      completedOrders: "Pedidos Concluidos",
      cardNotAvailable: "Pagamentos com cartão não estão disponíveis atualmente para esta conta.",
      useAlternative: "Por favor use PayPal ou Crypto como método de pagamento. Você também pode pagar com cartão diretamente no checkout através do PayPal.",
      initializingPayPal: "Inicializando entrada segura de cartão...",
      secureCardNote: "Os dados do cartão são tratados de forma segura pelo PayPal. Nunca vemos ou armazenamos seu número de cartão completo ou CVV.",
      cardNumber: "Número do Cartão",
      expiryDate: "Data de Validade",
      savingCard: "Salvando cartão...",
      saveCardSecurely: "Salvar Cartão de Forma Segura via PayPal",
      poweredByPayPal: "Processamento Seguro de Cartões pelo PayPal",
      cardSaveError: "Falha ao salvar cartão. Por favor verifique os dados e tente novamente.",
      securedViaPayPal: "Protegido via PayPal"
    },
    
    checkout: {
      title: "Checkout",
      orderSummary: "Resumo",
      purchasingAs: "Comprando como",
      pleaseSignIn: "Entre para completar",
      paymentMethod: "Pagamento",
      creditCard: "PayPal / Cartão",
      total: "Total",
      pay: "Pagar",
      processing: "Processando...",
      securePayment: "Pagamento seguro via PayPal.",
      success: "Pagamento Realizado!",
      successMessage: "Obrigado! Links enviados por email.",
      goToDashboard: "Ir ao Painel",
      continueShopping: "Continuar Comprando",
      cancelled: "Pagamento Cancelado",
      cancelledMessage: "Nenhum valor cobrado.",
      backToHome: "Voltar ao Início"
    },
    
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      autoPay: "Pagamento Automatico",
      autoPayDesc: "Cobrar automaticamente o metodo padrao para assinaturas",
      cardSecureNote: "Armazenamos apenas marca, ultimos 4 digitos e vencimento. Dados completos sao tratados pelo PayPal.",
      cardBrand: "Bandeira do Cartao",
      lastFour: "Ultimos 4 Digitos",
      expiration: "Vencimento",
      save: "Salvar",
      delete: "Excluir",
      edit: "Editar",
      view: "Ver",
      close: "Fechar",
      back: "Voltar",
      next: "Próximo",
      previous: "Anterior",
      search: "Buscar",
      filter: "Filtrar",
      sort: "Ordenar",
      all: "Tudo",
      none: "Nenhum",
      yes: "Sim",
      no: "Não"
    },
    officialPresence: {
      overline: "Presença Oficial",
      title1: "Música real. Playlists reais.",
      title2: "Audiência real.",
      description: "OG MUSIC já está nas principais plataformas. Ouça nossa música, explore nossas playlists curadas e verifique nosso ecossistema real com seguidores ativos e atividade real.",
      badges: ["Música já ao vivo", "Seguidores reais", "Playlists ativas", "Presença mundial"],
      spotifySubtitle: "Perfil Oficial do Spotify",
      spotifyDesc: "Explore nossas playlists curadas e descubra o som do ecossistema OG MUSIC. Música real, atividade real, seguidores reais já ouvindo.",
      spotifyFeatures: ["Playlists de artistas curadas", "Coleções por gênero", "Rotações de novos lançamentos"],
      spotifyBtn: "Ouvir no Spotify",
      youtubeSubtitle: "Canal Oficial do YouTube",
      youtubeDesc: "Assista lançamentos oficiais, conteúdo dos bastidores e experimente o lado visual da marca OG MUSIC no YouTube.",
      youtubeFeatures: ["Lançamentos musicais oficiais", "Showcases de artistas", "Conteúdo de marca e novidades"],
      youtubeBtn: "Assistir no YouTube",
      trustMessage: "Tudo o que você vê é real. Nossa música está ao vivo, nossas playlists estão ativas e pessoas reais já estão ouvindo. Verifique você mesmo no Spotify e YouTube."
    },
    featuredArtists: {
      overline: "Artistas Verificados",
      title1: "Artistas reais. Lançamentos reais.",
      title2: "Plataformas reais.",
      description: "Alguns artistas já estão trabalhando com OG MUSIC e têm sua música nas principais plataformas como Spotify e YouTube. Explore seus perfis e experimente a qualidade por trás do nosso ecossistema.",
      trustLine: "Isso não é um conceito — já está acontecendo.",
      bottomText: "Verifique a qualidade, o som e a presença dos artistas da OG MUSIC diretamente no Spotify.",
      viewAll: "Ver Todos os Artistas"
    },
    artistsPage: {
      overline: "Ecossistema OG MUSIC",
      title1: "Os Artistas já Confiam na",
      description: "Artistas reais. Lançamentos reais. Plataformas reais. Explore os perfis de artistas que já trabalham dentro do ecossistema OG MUSIC e ouça sua música no Spotify e em todas as principais plataformas.",
      trustLine: "Isso não é um conceito — já está acontecendo.",
      ctaTitle1: "Ouça Música Real já",
      ctaTitle2: "Lançada",
      ctaDesc: "Cada artista mostrado aqui foi lançado através do sistema OG MUSIC. Sua música está ao vivo, posicionada no mercado e disponível para você verificar diretamente no Spotify.",
      ctaBadges: ["Masterização Profissional", "Distribuição Completa", "Identidade de Marca", "Ecossistema de Playlists"],
      explorePacks: "Explorar Packs de Música",
      joinMembership: "Entrar na Assinatura",
      aiPlaceholder: "Que tipo de música você precisa? Eu ajudo.",
      aiSend: "Enviar",
      aiRecommended: "Recomendados para você:"
    },
    legal: {
      backToHome: "Voltar ao Início",
      lastUpdated: "Última atualização: Abril 2026",
      termsTitle: "Termos e Condições",
      termsContent: {
        s1t: "1. Aceitação dos Termos",
        s1: "Ao acessar e usar a plataforma OG MUSIC GROUP (\"Serviço\"), você aceita e concorda em cumprir estes Termos e Condições.",
        s2t: "2. Serviços Fornecidos",
        s2: "OG MUSIC GROUP fornece um marketplace de música digital que oferece: faixas prontas para lançamento (MP3 e WAV), licenças musicais comerciais (Básica e Exclusiva), packs e bundles musicais, planos de assinatura e serviços de lançamento de artistas.",
        s3t: "3. Contas de Usuário",
        s3: "Para fazer compras, você deve criar uma conta com um endereço de email válido. Você é responsável por manter a confidencialidade de suas credenciais.",
        s4t: "4. Compras e Pagamentos",
        s4: "Todos os preços são em USD. Pagamentos processados via PayPal e criptomoedas (USDT TRC20, Bitcoin). Os arquivos digitais são entregues automaticamente por email.",
        s5t: "5. Termos de Licença",
        s5: "A música comprada vem com um contrato de licença. Consulte nossa página de Licenciamento para detalhes completos.",
        s6t: "6. Propriedade Intelectual",
        s6: "Todo o conteúdo é propriedade do OG MUSIC GROUP. A compra de uma licença concede direitos de uso específicos.",
        s7t: "7. Usos Proibidos",
        s7: "Você não pode revender, redistribuir ou compartilhar arquivos comprados em sua forma original.",
        s8t: "8. Limitação de Responsabilidade",
        s8: "OG MUSIC GROUP não será responsável por danos indiretos resultantes do uso do Serviço.",
        s9t: "9. Alterações nos Termos",
        s9: "Reservamo-nos o direito de modificar estes termos a qualquer momento.",
        s10t: "10. Contato",
        s10: "Para perguntas, entre em contato em"
      },
      privacyTitle: "Política de Privacidade",
      privacyContent: {
        s1t: "1. Informações que Coletamos",
        s1: "Coletamos informações fornecidas diretamente: nome, email e informações de pagamento.",
        s2t: "2. Como Usamos suas Informações",
        s2: "Usamos suas informações para processar compras, enviar confirmações e melhorar nosso serviço.",
        s3t: "3. Processamento de Pagamentos",
        s3: "Pagamentos processados via PayPal e redes de criptomoedas. Não armazenamos dados completos do cartão.",
        s4t: "4. Compartilhamento de Dados",
        s4: "Não vendemos suas informações pessoais a terceiros.",
        s5t: "5. Segurança de Dados",
        s5: "Implementamos medidas de segurança padrão da indústria incluindo HTTPS e tokens JWT.",
        s6t: "6. Cookies",
        s6: "Usamos cookies essenciais para autenticação e gerenciamento de sessão.",
        s7t: "7. Seus Direitos",
        s7: "Você tem direito de acessar, corrigir e excluir seus dados pessoais.",
        s8t: "8. Retenção de Dados",
        s8: "Mantemos suas informações enquanto sua conta estiver ativa.",
        s9t: "9. Contato",
        s9: "Para perguntas de privacidade, entre em contato em"
      },
      refundTitle: "Política de Reembolso",
      refundContent: {
        s1t: "1. Política de Produtos Digitais",
        s1: "Devido à natureza dos produtos digitais, todas as vendas são geralmente finais uma vez entregues.",
        s2t: "2. Quando Reembolsos são Concedidos",
        s2: "Forneceremos reembolso se os links falharem, cobranças duplicadas, arquivos corrompidos ou erros técnicos.",
        s3t: "3. Quando Reembolsos não são Concedidos",
        s3: "Não emitimos reembolsos por mudança de opinião, limitações de software ou compras acima de 30 dias.",
        s4t: "4. Reembolsos de Assinatura",
        s4: "Assinaturas podem ser canceladas a qualquer momento. Reembolso total se cancelado em 7 dias sem downloads.",
        s5t: "5. Reembolsos de Licença Exclusiva",
        s5: "Compras de licença exclusiva não são reembolsáveis após emissão.",
        s6t: "6. Como Solicitar Reembolso",
        s6: "Entre em contato em support@ogmusicgroup.com com seu ID de pedido.",
        s7t: "7. Processamento de Reembolsos",
        s7: "Reembolsos aprovados serão processados pelo método de pagamento original em 5-10 dias úteis."
      }
    },
    licensingPage: {
      overline: "Guia de Licenciamento",
      heroTitle: "Licenciamento Musical",
      heroTitleHighlight: "Explicado",
      heroSubtitle: "Entenda exatamente o que você pode fazer com a música comprada no OG MUSIC GROUP. Direitos claros, sem confusão.",
      whatYouCanDo: "O Que Você Pode Fazer com Sua Licença",
      cards: [
        { title: "Subir para Plataformas", desc: "Spotify, Apple Music, Amazon Music, YouTube Music, Deezer, Tidal e todos os distribuidores." },
        { title: "Monetizar Sua Música", desc: "Mantenha 100% da sua receita de streaming e royalties." },
        { title: "Uso Comercial", desc: "Use em vídeos, anúncios, podcasts, redes sociais e projetos comerciais." },
        { title: "Criar e Performar", desc: "Grave vocais, remixe, performe ao vivo e crie obras derivadas." }
      ],
      comparisonTitle: "Licença Básica vs Exclusiva",
      basicName: "Licença Básica",
      basicIncluded: "Incluída com cada faixa",
      basicDesc: "Direitos não exclusivos — a faixa permanece disponível para outros compradores.",
      basicFeatures: ["Uso comercial permitido", "Subir para Spotify, Apple Music, etc.", "Monetização de streams", "Uso em vídeos e redes sociais", "Gravar vocais e criar derivados", "Performances ao vivo", "Até 500.000 reproduções", "MP3 + WAV incluídos", "Certificado PDF incluído"],
      basicLimitations: ["Não exclusiva — outros podem licenciar", "Crédito ao OG MUSIC GROUP necessário"],
      exclusiveName: "Licença Exclusiva",
      exclusiveLabel: "PREMIUM",
      exclusiveIncluded: "Direitos totais de propriedade",
      exclusiveDesc: "Direitos exclusivos — a faixa é removida do catálogo e pertence somente a você.",
      exclusiveFeatures: ["Direitos exclusivos completos", "Streams e distribuição ilimitados", "Subir para todas as plataformas", "Direitos totais de monetização", "Uso em qualquer projeto comercial", "Modificar, remixar e criar derivados", "Sem necessidade de crédito", "MP3 + WAV + Stems", "Certificado PDF incluído", "Perpétua e não revogável", "Suporte prioritário incluído"],
      startingFrom: "A partir de",
      howTitle: "Como Funciona",
      steps: [
        { title: "Navegue e Ouça", desc: "Ouça as faixas e encontre seu som" },
        { title: "Escolha a Licença", desc: "Básica ou Exclusiva" },
        { title: "Compre Instantaneamente", desc: "PayPal, cartão ou cripto" },
        { title: "Receba os Arquivos", desc: "MP3 + WAV + Licença PDF por email" },
        { title: "Lance e Ganhe", desc: "Suba para seu distribuidor e lance" }
      ],
      faqTitle: "Perguntas Frequentes",
      faqs: [
        { q: "Posso subir música licenciada para o Spotify?", a: "Sim. Ambas as licenças permitem distribuição em todas as plataformas principais." },
        { q: "Posso monetizar streams?", a: "Sim. Você mantém 100% da receita de streaming e vendas." },
        { q: "Quais arquivos recebo?", a: "MP3, WAV e certificado de licença PDF com seus dados." },
        { q: "Qual a diferença entre Básica e Exclusiva?", a: "Básica é não exclusiva com limite de 500K. Exclusiva dá propriedade total sem limites." },
        { q: "Posso obter reembolso?", a: "Produtos digitais geralmente não são reembolsáveis. Veja nossa Política de Reembolso." }
      ],
      ctaTitle: "Pronto para Obter Sua Música?",
      ctaDesc: "Explore nosso catálogo premium e encontre seu próximo sucesso.",
      browseCatalog: "Explorar Catálogo",
      viewPacks: "Ver Packs"
    },
    aboutPage: {
      overline: "Nossa História",
      title: "Sobre OG MUSIC",
      introDefault: "OG MUSIC GROUP é um ecossistema musical completo dedicado à produção, distribuição e licenciamento de música pronta para lançamento.",
      whatWeOffer: "O Que Oferecemos",
      offers: [
        { title: "Faixas Masterizadas", desc: "Música profissional pronta para projetos comerciais." },
        { title: "Licenças Comerciais", desc: "Direitos claros para uso comercial com documentação legal." },
        { title: "Assinaturas", desc: "Acesso ilimitado ao catálogo completo." },
        { title: "Lançamento de Artistas", desc: "Sistema completo para lançar sua carreira musical." }
      ],
      visionTitle: "Nossa Visão",
      visionDefault: "Nossa visão é construir a plataforma musical mais acessível e profissional do mundo.",
      teamTitle: "Nossa Equipe",
      teamDefault: "Uma equipe criativa e técnica dedicada a produzir música de nível profissional.",
      teamLabels: ["Produção Musical", "Estúdio Criativo", "Sessões de Trabalho"],
      howTitle: "Como Trabalhamos",
      howWeWork: [
        { title: "Música Pronta para Lançar", desc: "Faixas masterizadas prontas para distribuição em todas as plataformas." },
        { title: "Sistema de Licenças", desc: "Licenças comerciais claras com documentação PDF." },
        { title: "Lançamento de Artistas", desc: "Sistema completo: identidade visual, distribuição e presença em plataformas." },
        { title: "Ecossistema de Playlists", desc: "Rede de playlists curadas no Spotify para gerar streams reais." }
      ],
      trustTitle: "Ecossistema Musical Ativo",
      trustElements: [
        "Ecossistema musical ativo",
        "Artistas em plataformas reais",
        "Música pronta para distribuição global",
        "+50 artistas lançados",
        "Licenças comerciais verificadas",
        "Presença no Spotify, YouTube e mais"
      ],
      exploreCatalog: "Explorar Catálogo",
      viewArtists: "Ver Artistas",
      founderOverline: "Sobre o Fundador"
    },
    faqPage: {
      overline: "Perguntas Frequentes",
      title: "Perguntas Frequentes",
      subtitle: "Encontre respostas para as perguntas mais comuns sobre nossa música, licenças e plataforma.",
      empty: "Nenhuma pergunta frequente disponível ainda.",
      ctaTitle: "Ainda tem perguntas?",
      ctaDesc: "Nossa equipe está aqui para ajudar. Entre em contato a qualquer momento.",
      ctaButton: "Contatar Suporte"
    }
  }
};

export default translations;
